
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("a5txT", function(module, exports) {

var $7xVCs = parcelRequire("7xVCs");

const $82982cff56793d8b$var$standalonePageTreeStateUpdater = new (0, $7xVCs.PageTreeStateUpdater)();
const $82982cff56793d8b$export$19e3952b1a66ecb = ()=>$82982cff56793d8b$var$standalonePageTreeStateUpdater;
module.exports["getStandalonePageTreeStateUpdater"] = $82982cff56793d8b$export$19e3952b1a66ecb;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("b1HmN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("kHp2S"))).ChangeEditionNotificationDialog
});
module.exports["LoadableChangeEditionNotificationDialog"] = $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6;

});

parcelRegister("kHp2S", function(module, exports) {

let $f11b404c5fa8cafa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f11b404c5fa8cafa$var$load("hhss7"),
    $f11b404c5fa8cafa$var$load("kSVGa")
]).then(()=>parcelRequire('5BDEU'));

});

parcelRegister("5ZPtT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5ea117b10605f60a$export$6d1402fb58384e4f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OP-5u",
    name: "PageLayout",
    loader: async ()=>(await (parcelRequire("8QsVO"))).PageLayout
});
module.exports["PageLayout"] = $5ea117b10605f60a$export$6d1402fb58384e4f;

});

parcelRegister("8QsVO", function(module, exports) {

let $67099f3f475a6a02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $67099f3f475a6a02$var$load("dP7ao"),
    $67099f3f475a6a02$var$load("i8eeg"),
    $67099f3f475a6a02$var$load("iFdoJ"),
    $67099f3f475a6a02$var$load("5tmW9"),
    $67099f3f475a6a02$var$load("cpQv0"),
    $67099f3f475a6a02$var$load("4Nzvy"),
    $67099f3f475a6a02$var$load("loqJg"),
    $67099f3f475a6a02$var$load("e7ZUf"),
    $67099f3f475a6a02$var$load("gL8bn"),
    $67099f3f475a6a02$var$load("6iz6l"),
    $67099f3f475a6a02$var$load("4SCW2"),
    $67099f3f475a6a02$var$load("bu7LS"),
    $67099f3f475a6a02$var$load("a7nvi"),
    $67099f3f475a6a02$var$load("282rq"),
    $67099f3f475a6a02$var$load("a9w2G"),
    $67099f3f475a6a02$var$load("3Kg3S"),
    $67099f3f475a6a02$var$load("6wr18"),
    $67099f3f475a6a02$var$load("9aMWm"),
    $67099f3f475a6a02$var$load("9I9wd"),
    $67099f3f475a6a02$var$load("1aPQ5"),
    $67099f3f475a6a02$var$load("dfdnK"),
    $67099f3f475a6a02$var$load("lR1oM"),
    $67099f3f475a6a02$var$load("iTzK7"),
    $67099f3f475a6a02$var$load("btlgC"),
    $67099f3f475a6a02$var$load("kUMFm"),
    $67099f3f475a6a02$var$load("6tsCm"),
    $67099f3f475a6a02$var$load("4vxCt"),
    $67099f3f475a6a02$var$load("iYF63"),
    $67099f3f475a6a02$var$load("fSawH"),
    $67099f3f475a6a02$var$load("dndbG"),
    $67099f3f475a6a02$var$load("kLojH"),
    $67099f3f475a6a02$var$load("6jGZ7"),
    $67099f3f475a6a02$var$load("6XCf4"),
    $67099f3f475a6a02$var$load("dChec"),
    $67099f3f475a6a02$var$load("9ldRJ"),
    $67099f3f475a6a02$var$load("19XET"),
    $67099f3f475a6a02$var$load("1qlDN"),
    $67099f3f475a6a02$var$load("1yVM6"),
    $67099f3f475a6a02$var$load("dRpV3"),
    $67099f3f475a6a02$var$load("ffEVr"),
    $67099f3f475a6a02$var$load("ic26z"),
    $67099f3f475a6a02$var$load("itWY8"),
    $67099f3f475a6a02$var$load("jXx9i"),
    $67099f3f475a6a02$var$load("5dBst"),
    $67099f3f475a6a02$var$load("6QHHT"),
    $67099f3f475a6a02$var$load("a6XkF"),
    $67099f3f475a6a02$var$load("2vAWg"),
    $67099f3f475a6a02$var$load("7cABH"),
    $67099f3f475a6a02$var$load("bYmo7"),
    $67099f3f475a6a02$var$load("9jjvO"),
    $67099f3f475a6a02$var$load("kWjLh"),
    $67099f3f475a6a02$var$load("Wowvf"),
    $67099f3f475a6a02$var$load("9LW4b"),
    $67099f3f475a6a02$var$load("hhss7"),
    $67099f3f475a6a02$var$load("7EorR"),
    $67099f3f475a6a02$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("ezLwY", function(module, exports) {
parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cpjd2 = parcelRequire("cpjd2");

const $a9c9343047c8f651$var$contexts = {};
const $a9c9343047c8f651$var$runSafely = (fn)=>{
    try {
        fn();
    } catch (e) {
        // TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
        console.error(e);
    }
};
const $a9c9343047c8f651$export$2cd8252107eb640b = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!confluence-keyboard-shortcuts-batch'
    ], ()=>{
        $a9c9343047c8f651$var$runSafely(()=>{
            (0, $3IK76.bind)('register-contexts.keyboardshortcuts', (e, data)=>{
                const { enableContext: enableContext } = data.shortcutRegistry;
                Object.entries($a9c9343047c8f651$var$contexts).forEach(([context, enabled])=>{
                    if (enabled) enableContext(context);
                });
            });
            (0, $3IK76.trigger)('initialize.keyboardshortcuts');
        });
    }, ()=>{});
};
const $a9c9343047c8f651$export$e758fd0259c79269 = ()=>{
    // We need to disable all shortcuts and enable again
    // the ones still available as the currrent library doesn't expose a
    // method for removing just one context and we want to keep previous
    // added contexts alive
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
        (0, $3IK76.trigger)('initialize.keyboardshortcuts');
    });
};
const $a9c9343047c8f651$var$makeSetContext = (enable)=>(newContexts)=>{
        if (!Array.isArray(newContexts)) newContexts = [
            newContexts
        ];
        newContexts.forEach((context)=>{
            if ($a9c9343047c8f651$var$contexts[context] !== enable) {
                $a9c9343047c8f651$var$contexts[context] = enable;
                $a9c9343047c8f651$export$e758fd0259c79269();
            }
        });
    };
const $a9c9343047c8f651$export$2ca78a0e32b5ba4e = $a9c9343047c8f651$var$makeSetContext(true);
const $a9c9343047c8f651$export$48a00fd3a2cf40e0 = $a9c9343047c8f651$var$makeSetContext(false);
const $a9c9343047c8f651$export$4794d9b1949031cf = ()=>{
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
    });
};
module.exports["init"] = $a9c9343047c8f651$export$2cd8252107eb640b;
module.exports["enableContext"] = $a9c9343047c8f651$export$2ca78a0e32b5ba4e;
module.exports["disableContext"] = $a9c9343047c8f651$export$48a00fd3a2cf40e0;
module.exports["teardown"] = $a9c9343047c8f651$export$4794d9b1949031cf;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("fmuCC", function(module, exports) {

let $b2f0a9f0e00b7e22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2f0a9f0e00b7e22$var$load("lgm1i").then(()=>parcelRequire('04Nru'));

});

parcelRegister("jzEl8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
function $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode = window.document) {
    if (!rootNode) return [];
    return Array.from(rootNode.querySelectorAll(selectors.join(',')));
}
function $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(domElement) {
    if (!domElement.hasAttributes()) return {};
    return Object.values(domElement.attributes).reduce((acc, attr)=>{
        acc[attr.name] = attr.value;
        return acc;
    }, {});
}
const $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 = /*#__PURE__*/ (0, $42omo.memo)(function LegacyDOMBridge({ selectors: selectors, attempts: attempts = 1, retryDelay: retryDelay = 50, rootNode: rootNode, portalNode: portalNode, replacePlaceholderWith: replacePlaceholderWith, deleteExistingContent: deleteExistingContent = true }) {
    const [portals, setPortals] = (0, $42omo.useState)([]);
    const workerInProgressRef = (0, $42omo.useRef)(false);
    const portalsRef = (0, $42omo.useRef)([]);
    const replaceDOMElementsWithPortal = (0, $42omo.useCallback)((attemptsLeft)=>{
        workerInProgressRef.current = true;
        $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode).forEach((node)=>{
            const currentNodeAttrs = $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(portalNode, currentNodeAttrs);
                portalsRef.current.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(reactEl, targetNode));
            }
        });
        const remaining = attemptsLeft - 1;
        setPortals([
            ...portalsRef.current
        ]);
        if (remaining > 0) window.setTimeout(()=>{
            replaceDOMElementsWithPortal(remaining);
        }, retryDelay);
        else workerInProgressRef.current = false;
    }, [
        selectors,
        rootNode,
        portalNode,
        replacePlaceholderWith,
        deleteExistingContent,
        retryDelay
    ]);
    (0, $42omo.useEffect)(()=>{
        if (attempts > 0 && !workerInProgressRef.current) {
            const timerId = setTimeout(()=>{
                replaceDOMElementsWithPortal(attempts);
            }, 0);
            return ()=>clearTimeout(timerId);
        }
    }, [
        attempts,
        replaceDOMElementsWithPortal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portals);
});
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("5qwh1", function(module, exports) {

let $3f386a518f113b7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f386a518f113b7b$var$load("6wr18"),
    $3f386a518f113b7b$var$load("j06N4"),
    $3f386a518f113b7b$var$load("ffEVr"),
    $3f386a518f113b7b$var$load("Wowvf"),
    $3f386a518f113b7b$var$load("hhss7"),
    $3f386a518f113b7b$var$load("lwfE5")
]).then(()=>parcelRequire('MkVVm'));

});

parcelRegister("2NJWg", function(module, exports) {

let $20a3cae097b49b58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20a3cae097b49b58$var$load("6wr18"),
    $20a3cae097b49b58$var$load("ffEVr"),
    $20a3cae097b49b58$var$load("Wowvf"),
    $20a3cae097b49b58$var$load("hhss7"),
    $20a3cae097b49b58$var$load("d7sp9")
]).then(()=>parcelRequire('4Au5p'));

});

parcelRegister("cq0jI", function(module, exports) {

let $90a828add24c033b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90a828add24c033b$var$load("hhss7"),
    $90a828add24c033b$var$load("ei0Jg")
]).then(()=>parcelRequire('esrJ1'));

});

parcelRegister("7nmkU", function(module, exports) {

let $55ec01e1fb53735b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55ec01e1fb53735b$var$load("hhf8b").then(()=>parcelRequire('cDa2P'));

});

parcelRegister("g2IUi", function(module, exports) {

let $badfaad7e02a4b94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $badfaad7e02a4b94$var$load("6jGZ7"),
    $badfaad7e02a4b94$var$load("82QsP"),
    $badfaad7e02a4b94$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});

parcelRegister("1xDOQ", function(module, exports) {

let $11f7c2bbbba765cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11f7c2bbbba765cf$var$load("6jGZ7"),
    $11f7c2bbbba765cf$var$load("82QsP"),
    $11f7c2bbbba765cf$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("14QAi", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");


var $lzcvT = parcelRequire("lzcvT");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

$parcel$global.rwr("3pblT", () => { var $66e15fc290e40a9b$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3pblT\",\"standalone-navigation-jquery3.a85f8b9b.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.bde70d07.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.fea73d48.js\",\"gmHzx\",\"PageLayout.4d51588f.js\",\"i5eMd\",\"cs.f871667f.js\",\"4UPfH\",\"da.88e1ae17.js\",\"gd4qs\",\"de.fbb4babb.js\",\"fviv5\",\"en-GB.30c8d220.js\",\"hEkXc\",\"en-US.c2f93eaf.js\",\"6oOC9\",\"en-XA.353d5d17.js\",\"le1sE\",\"en-XB.0903e023.js\",\"eBoC7\",\"en-ZZ.8aec10e4.js\",\"bNv64\",\"es.47499be0.js\",\"bAoKR\",\"et.b46b672c.js\",\"4Afgd\",\"fi.e415556a.js\",\"cMubu\",\"fr.96ba1380.js\",\"oUCro\",\"hr.665c3168.js\",\"3fLE9\",\"hu.ecf1ecf0.js\",\"8hOn0\",\"it.1b9b131c.js\",\"h4OCL\",\"ja.e3c94db4.js\",\"bcQs2\",\"ko.5b772f8f.js\",\"aBa7j\",\"nb.50a37924.js\",\"b544F\",\"nl.86e0cb25.js\",\"K6fhx\",\"pl.bf7f98ff.js\",\"gZU54\",\"pt-BR.d2d9241f.js\",\"hlJc4\",\"ro.968019e9.js\",\"4Wdqb\",\"ru.61a950c8.js\",\"bJMZS\",\"sl.36363fa9.js\",\"exiT6\",\"sr-RS.3450f456.js\",\"jLkRH\",\"sr-YR.99ef1f81.js\",\"dmrYq\",\"sr.7f38330b.js\",\"k10Cs\",\"sv.5e670a7a.js\",\"g5LV7\",\"th.7e0265b8.js\",\"1n8w9\",\"tr.ff559801.js\",\"2QtDQ\",\"uk.770975d9.js\",\"i2vEA\",\"vi.a6fd15d2.js\",\"f1B4n\",\"zh-CN.be0328c0.js\",\"l079e\",\"zh-TW.37d2d4d3.js\",\"bv8GZ\",\"cs.b8d1c1b1.js\",\"cdeuH\",\"da.42823f82.js\",\"7gF8f\",\"de.8842c040.js\",\"djb49\",\"en-GB.0eb379a4.js\",\"koawN\",\"en-US.8577a1a6.js\",\"6htQT\",\"en-XA.33547c1c.js\",\"fi75i\",\"en-XB.e8a30a9e.js\",\"ksTQ6\",\"en-ZZ.2f8e37d6.js\",\"5CGnz\",\"es.98f8e90e.js\",\"X0Jic\",\"et.155c1ee0.js\",\"9Oxgj\",\"fi.f2f3389c.js\",\"kAg8V\",\"fr.368a32d8.js\",\"36XYg\",\"hr.ea791c71.js\",\"fM2oh\",\"hu.f2f9ae82.js\",\"xnqy2\",\"it.351ab003.js\",\"awkVi\",\"ja.99d2f833.js\",\"11DLa\",\"ko.8aeaf96b.js\",\"barSq\",\"nb.4503e9a5.js\",\"a8heY\",\"nl.6070b16e.js\",\"6hlNE\",\"pl.9a5b0b0f.js\",\"2bqSD\",\"pt-BR.10f91e79.js\",\"j6IGj\",\"ro.b5d74be6.js\",\"bJykp\",\"ru.2a448b30.js\",\"7Rbde\",\"sl.9bd17812.js\",\"l8auu\",\"sr-RS.de35f66e.js\",\"3ColL\",\"sr-YR.6d75fa4f.js\",\"2VSOH\",\"sr.cbf031a6.js\",\"dh2Er\",\"sv.e6031ecb.js\",\"kyBJI\",\"th.ea68a7ea.js\",\"eBLgB\",\"tr.a4d35ce1.js\",\"ahhGv\",\"uk.13d42b80.js\",\"1Zesg\",\"vi.e3d9da82.js\",\"eLlpV\",\"zh-CN.914fb213.js\",\"bV8sS\",\"zh-TW.90b55434.js\",\"1jsQH\",\"cs.688247af.js\",\"deyvi\",\"da.ce01a3f4.js\",\"6dERU\",\"de.196d0286.js\",\"kTurq\",\"en-GB.b800b839.js\",\"fbIIm\",\"en-US.0fcdf1ae.js\",\"7l3it\",\"en-XA.c07d05b7.js\",\"i64HJ\",\"en-XB.bbf09203.js\",\"j0PWv\",\"en-ZZ.552e2090.js\",\"dlmud\",\"es.a37dad44.js\",\"7snhF\",\"et.20d4d799.js\",\"cbkj0\",\"fi.c129a5d2.js\",\"17m16\",\"fr.d48d2214.js\",\"eQZk8\",\"hr.e3f3497b.js\",\"b4NO6\",\"hu.d63219d9.js\",\"1K1Fj\",\"it.68b18a63.js\",\"38sfA\",\"ja.05e83d89.js\",\"bjmre\",\"ko.5d08c8ec.js\",\"asvK9\",\"nb.b60c8cb7.js\",\"7v6wU\",\"nl.d417f24d.js\",\"aEpRh\",\"pl.26cf010d.js\",\"3fuR9\",\"pt-BR.b55187ea.js\",\"bSjyK\",\"ro.8940bbdc.js\",\"fMrUo\",\"ru.f0bbf79a.js\",\"glLvq\",\"sl.93d481e6.js\",\"fFGjZ\",\"sr-RS.ddc08819.js\",\"fEAqG\",\"sr-YR.289dc38a.js\",\"e9tHh\",\"sr.14f31eee.js\",\"9eNkX\",\"sv.12cce2b0.js\",\"fTPgj\",\"th.4d360fb6.js\",\"h0uBE\",\"tr.a1624066.js\",\"lKa7i\",\"uk.38ddf7bc.js\",\"9aufD\",\"vi.4cc44e33.js\",\"gDiIK\",\"zh-CN.268ccaa6.js\",\"j9OUx\",\"zh-TW.9fda702e.js\",\"kpHRm\",\"GeneralShortcutListener.8e29901c.js\",\"5dBst\",\"ShareButton.8dbf9eac.js\",\"hwiu3\",\"NavigationLockout.530bed26.js\",\"fYNhh\",\"DevToolsDialog.3c7bce40.js\",\"hqXh1\",\"OnboardingStateEditor.c7feae17.js\",\"ffEVr\",\"vendors~editor_icon.f597614a.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.ef2af5ea.js\",\"6wr18\",\"vendors~editor_icon.d614ee58.js\",\"331QJ\",\"statsigIcon.d38e3090.png\",\"dKuGS\",\"switcherooIcon.4d3f783a.png\",\"fxolc\",\"MigrationsToolingTab.b456cc51.js\",\"4Nzvy\",\"manual-triggers-modal.71f03a03.js\",\"7EorR\",\"vendors~editor_atlaskit_md.c714ce11.js\",\"kHOMt\",\"manual-triggers-modal.63f58b3c.js\",\"4ukIM\",\"GoalPanel.2b4be50a.js\",\"heWL2\",\"body.8dcf62d1.js\",\"8makw\",\"datasourceTableView.1c05017f.js\",\"iNa18\",\"datasourceTableView.86fa06a3.js\",\"dRpV3\",\"modal.72e041ba.js\",\"lkOIY\",\"CommentEditor.49619d4c.js\",\"C72jX\",\"DevToolsBanner.60797453.js\",\"avZlC\",\"BannerContainer.46b58da7.js\",\"kiqoj\",\"SuperAdminBanner.bf29dfb5.js\",\"gdXTv\",\"SuperAdminSatisfactionSurvey.b6e4949f.js\",\"jE5XU\",\"SatisfactionSurveyFlag.1cef0625.js\",\"f8xBv\",\"SatisfactionSurveyComponent.8f485896.js\",\"4csuu\",\"terrible.43df9387.svg\",\"ezTnP\",\"bad.1f02aedc.svg\",\"lKYkZ\",\"okay.fd894a28.svg\",\"eOIaN\",\"great.e17ca230.svg\",\"c1rvV\",\"amazing.0fceeb3a.svg\",\"hUS1e\",\"AdminAnnouncementBannerInner.37744d13.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"iFdoJ\",\"simpleHasher.408ecdad.js\",\"i8eeg\",\"simpleHasher.runtime.1bd61c50.js\",\"43bid\",\"media.ab48dbd9.js\",\"foy8I\",\"FullPageEditorComponent.0dccf54e.js\",\"jYUNl\",\"FullPageEditorComponent.runtime.20d54534.js\",\"9cgaG\",\"AdminAnnouncementBannerInner.7527dce7.js\",\"jYUNl\",\"FullPageEditorComponent.runtime.20d54534.js\",\"i8eeg\",\"simpleHasher.runtime.1bd61c50.js\",\"cjDIz\",\"GracePeriodBanner.caebc31d.js\",\"2x6ML\",\"GracePeriodBanner.9325e4cc.js\",\"4zlcK\",\"avoid-deactivation-data-modal.9f08361b.js\",\"bpZy3\",\"user-brand-dark.2dd77a4f.svg\",\"4B6ye\",\"user-brand-light.f1d0cd78.svg\",\"g2AXX\",\"user-gray-dark.8d7964d6.svg\",\"30svi\",\"user-gray-light.4df874b4.svg\",\"dTsOE\",\"modal.b7388ff7.js\",\"jfplD\",\"GracePeriodBanner.66791589.js\",\"4uVag\",\"StorageEnforcementBanner.fde67f3f.js\",\"cGZdO\",\"PlanConsentDeepLink.e85c4404.js\",\"hmjlF\",\"ConsentBannerWrapper.7af0ec12.js\",\"exJm1\",\"browser-storage-controls.14e9852f.js\",\"gCbq8\",\"cs.7436d98d.js\",\"TR24h\",\"da.0fda5702.js\",\"NfUyB\",\"de.e5effe1d.js\",\"4v21d\",\"en_GB.b2ee5e0f.js\",\"4D2WV\",\"en_ZZ.bf5bcccc.js\",\"gSwbJ\",\"es.e94adf07.js\",\"chaHI\",\"fi.57e55966.js\",\"kBpIt\",\"fr.857dbfb8.js\",\"dPeMl\",\"hu.62aac983.js\",\"4PHEa\",\"it.87a76ceb.js\",\"CGYMd\",\"ja.b27ab8f9.js\",\"fGpBg\",\"ko.c649863e.js\",\"cgWNw\",\"nb.06ab23c2.js\",\"aUP3I\",\"nl.2de2b14b.js\",\"bs4gz\",\"pl.04707932.js\",\"gSXrz\",\"pt_BR.cb20fcaa.js\",\"aJd4I\",\"ru.863d92b1.js\",\"gR7fm\",\"sv.01d4edea.js\",\"xDkFq\",\"th.476d97f0.js\",\"cV2OA\",\"tr.51255c6c.js\",\"ehLR6\",\"uk.35ddae6c.js\",\"lXmbw\",\"vi.859e9add.js\",\"jwfyA\",\"zh_TW.199442db.js\",\"6zOB9\",\"zh.2de0f28e.js\",\"7ETma\",\"BannerContainer.6775102c.js\",\"jryQt\",\"GlobalComponents.f96830c4.js\",\"lnKog\",\"main.53faa88d.js\",\"bIPPg\",\"main.a3f62875.js\",\"hJpvQ\",\"main.5997b0b8.js\",\"8XUdf\",\"SingleImportModal.cfc0b0a6.js\",\"iYYAa\",\"googleDocs.076e85b0.svg\",\"c0FzQ\",\"word.87639ee0.svg\",\"b3JYn\",\"oneDriveLogo.a603c61e.svg\",\"3WaAl\",\"FloatingAudioContent.7d398b4a.js\",\"aLGWB\",\"WaveformAnimation.27743507.js\",\"50ame\",\"render.0bafeca6.js\",\"9anPW\",\"render.9da9b827.js\",\"ivNGg\",\"GeneratingAnimation.1e1e5744.js\",\"hVPSr\",\"AudioBriefingSonicMark.b774c076.mp3\",\"cpQv0\",\"TeamProfileCardEntryPoint.7d509cd0.js\",\"77NEU\",\"UpdateComposer.e66697c6.js\",\"hogcU\",\"component-lazy.d0028dda.js\",\"9dXbh\",\"FullPageEditorComponent.01bdd534.js\",\"bIjrH\",\"FullPageEditorComponent.runtime.1a08747e.js\",\"cyGuT\",\"feedback-collector.b720ab58.js\",\"7269o\",\"RelatedLinksModal.9adfd691.js\",\"2zxmz\",\"RelatedLinksModal.runtime.5231a831.js\",\"kjZZD\",\"vendors~editor_icon-object.41124b36.js\",\"ffEVr\",\"vendors~editor_icon.f597614a.js\",\"6wr18\",\"vendors~editor_icon.d614ee58.js\",\"kNV5Y\",\"blog.3e99625c.js\",\"dYtBN\",\"page-live-doc.23a58848.js\",\"dek7I\",\"page-live-doc.4dfdcb4e.js\",\"hv4mn\",\"modal.860760a9.js\",\"fisfU\",\"video-play-overlay.0278a0bb.js\",\"8YSo7\",\"TeamProfileCardEntryPoint.b0d3f2e3.js\",\"7kkP6\",\"playlist-add.9dfed2d4.js\",\"k2R9e\",\"playlist-remove.1cea3c51.js\",\"lLK0D\",\"video-pause-overlay.bf3f58b5.js\",\"8gJl0\",\"video-previous-overlay.a5089076.js\",\"lVBal\",\"video-skip-backward-fifteen.7d60ceff.js\",\"7t5Ax\",\"video-skip-forward-fifteen.8c41b0f7.js\",\"jDjSj\",\"16.1d00245e.js\",\"5tmW9\",\"NativeCollabComponent.d745cab0.js\",\"9T2Kw\",\"EndOfPageRecommendation.5ff45e4e.js\",\"8r23A\",\"EndOfPageRecommendation.runtime.abb86639.js\",\"l1nJ9\",\"ConversationAssistant.7aea4ad8.js\",\"2zxmz\",\"RelatedLinksModal.runtime.5231a831.js\",\"bIjrH\",\"FullPageEditorComponent.runtime.1a08747e.js\",\"8r23A\",\"EndOfPageRecommendation.runtime.abb86639.js\",\"atyNV\",\"CreateSpaceDrawer.0c9ec406.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"eMbU0\",\"SpaceSelector.880286ea.js\",\"3wN5D\",\"ExternalSpaceLozenge.f992c250.js\",\"9jjvO\",\"main.a591a5cc.js\",\"7cABH\",\"emoji.c301da09.js\",\"2vAWg\",\"emoji.runtime.979ba043.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"6aTYS\",\"SpaceSelector.ed3ca1a3.js\",\"lJJQ8\",\"ViewChangesDialog.e8425838.js\",\"8OiWl\",\"ChangesDiff.a64b1265.js\",\"lKP6d\",\"GetTheDetailsYouNeedDark.bbe9839d.gif\",\"4Yi9K\",\"GetTheDetailsYouNeedLight.9900190e.gif\",\"dtpmo\",\"SpaceSelector.ce8265d6.js\",\"2vAWg\",\"emoji.runtime.979ba043.js\",\"4yUSc\",\"PremiumLozenge.3830a299.js\",\"ePA5l\",\"Lozenge.2b93d1b5.js\",\"dJhDI\",\"Upload.41b8806c.svg\",\"4fscz\",\"skyBackground.807308bc.svg\",\"fxC6e\",\"24.abc70e31.js\",\"6vhrJ\",\"24.b27b3b60.js\",\"fsikk\",\"cardWithMediaClient.ea8ac2db.js\",\"a3Uq6\",\"esm.fbb2f874.js\",\"19uFC\",\"pages.d69df670.js\",\"7JvFY\",\"CopySpacePermissionsForLegacyNewSpace.e19c566d.js\",\"4o7bO\",\"CreateSpaceDrawer.51cffe94.js\",\"huUvS\",\"16.95572e52.js\",\"1oiJ6\",\"16.f20e72ef.js\",\"lxiFd\",\"16.6f66d48d.js\",\"eDqo1\",\"16.775f562b.js\",\"6HBYC\",\"16.e6a8a945.js\",\"bYxCZ\",\"16.1d6e89c2.js\",\"eTBsW\",\"16.a21a1ba3.js\",\"020xd\",\"16.4d1d2449.js\",\"ls0Um\",\"16.cbe8174e.js\",\"eVYW1\",\"16.71a0c4aa.js\",\"f35QR\",\"16.4bd4939d.js\",\"8j9XC\",\"cardWithMediaClient.8dd0f8cc.js\",\"b8BDn\",\"js.24b546d4.js\",\"dLFEp\",\"png-chunks-extract.6eed11e8.js\",\"9JWXo\",\"ImportContentDrawer.ca2c8c08.js\",\"6aruy\",\"media-client-react.4ea75121.js\",\"gOOwE\",\"cardWithMediaClient.75d15f4b.js\",\"cCWZm\",\"dropzone.b0db837a.js\",\"dT77m\",\"media-viewer-error-boundary.337cc089.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.5159dd30.js\",\"hqblC\",\"browser.9a2c48ae.js\",\"5eYbH\",\"fileIconLight.abb757fe.png\",\"f27VQ\",\"fileIconDark.2e9120d4.png\",\"eQRZh\",\"alexander.61c8c5b8.png\",\"k3UTH\",\"milo.2bdab175.png\",\"bpNrn\",\"vania.0f716e7d.png\",\"1SbNU\",\"newUsersIcon.57d15f82.png\",\"4pzfE\",\"entireWorkspaceGraphic.ec7c84e3.png\",\"9EbOe\",\"entireWorkspaceGraphicDark.a2cf125d.png\",\"5v8ge\",\"pageWithSubpagesGraphic.bc63f39a.png\",\"l5ApQ\",\"pageWithSubpagesGraphicDark.048b0716.png\",\"e233E\",\"NotionFileIcon.bf57d29e.png\",\"2HswK\",\"NotionFileIconDark.1bce2172.png\",\"iHoZ2\",\"mapNotionMembersIcon.f5fa6c65.png\",\"mKUlU\",\"mapNotionMembersIconDark.78a4caee.png\",\"lve0S\",\"dontMapNotionMembersIcon.d4b46256.png\",\"fHhNe\",\"dontMapNotionMembersIconDark.8a5a6302.png\",\"idIGV\",\"addRemainingMembersIcon.ed292f87.png\",\"eFqPt\",\"addRemainingMembersIconDark.fcaa97df.png\",\"ahBHt\",\"dontAddRemainingMembersIcon.c16498ed.png\",\"bJ6Qx\",\"dontAddRemainingMembersIconDark.2a9fa7cf.png\",\"jO0Zn\",\"copyPagePermissionsIcon.893f44bc.png\",\"koH91\",\"dontCopyPagePermissionsIcon.57c83ce6.png\",\"4qS5d\",\"createNewSpaceIcon.43619a57.png\",\"7HrUn\",\"createNewSpaceIconDark.1df6e816.png\",\"rGPsx\",\"dontCreateNewSpaceIcon.b35b2829.png\",\"5a1S5\",\"dontCreateNewSpaceIconDark.706b6cfd.png\",\"8R1Rz\",\"spaceTransferLight.b2e70613.png\",\"1e1ep\",\"spaceTransferDark.856b3d0e.png\",\"jGDZO\",\"zipFileIconLight.abb757fe.png\",\"4pvad\",\"zipFileIconDark.2e9120d4.png\",\"4xmnl\",\"spaceTransferIconLight.5eeae605.png\",\"aBnpB\",\"spaceTransferIconDark.9c0b5b2f.png\",\"aRCSw\",\"miroBulkImportIconLight.f695f170.png\",\"dur8E\",\"miroBulkImportIconDark.3dc15c83.png\",\"eGDQk\",\"Miro_Connie_Light.97ddc4df.png\",\"5IkEQ\",\"Miro_Connie_Dark.588133c4.png\",\"d4y04\",\"muralSpacesIllustrationLight.297ed65c.png\",\"hgEBB\",\"muralSpacesIllustrationDark.a5d03bf9.png\",\"4YW3x\",\"inviteMembersIconLight.1a833efb.png\",\"jw4LE\",\"inviteMembersIconDark.1179e32a.png\",\"hoRD8\",\"newSpaceIconLight.9405f85d.png\",\"5ILSM\",\"newSpaceIconDark.9c0b5b2f.png\",\"2Q5QN\",\"muralIcon.75d8302a.png\",\"fK2sh\",\"muralSpacesIllustrationDisconnectedLight.4bd334a6.png\",\"3aNue\",\"muralSpacesIllustrationDisconnectedDark.a6cca434.png\",\"7MlKm\",\"archive.dc010ead.js\",\"5uN9h\",\"arrow-up-right.b9da73d9.js\",\"9pso5\",\"MovePageDialog.6fb02b78.js\",\"hX5aL\",\"ImportContentModal.73afde50.js\",\"dIKKx\",\"StorageEnforcementFlags.3745c465.js\",\"52dqm\",\"GracePeriodModal.a672a1c0.js\",\"6sJUU\",\"GracePeriodModalComponent.a7f9b6b9.js\",\"gKiqN\",\"gracePeriodIllustrationDark.e34dd459.svg\",\"02fAA\",\"gracePeriodIllustrationLight.04bd67a4.svg\",\"gIOIL\",\"BlockCreateModal.62794ac7.js\",\"fDkpP\",\"blockCreateIllustrationLight.10953577.svg\",\"36KWd\",\"blockCreateIllustrationDark.e6b33366.svg\",\"ehu5c\",\"EndOfTrialModalContainer.04ae5919.js\",\"fkozR\",\"background-dark.46d9946a.svg\",\"3FECQ\",\"background-light.c76a8e81.svg\",\"doIPU\",\"gestural-line-dark.9e5d1ce8.svg\",\"dT0Nh\",\"gestural-line.93eaf758.svg\",\"cOOgy\",\"strike-through.539e2da9.svg\",\"fjOTL\",\"person-add.961e3a61.js\",\"aIwO0\",\"cs.b9edd2fb.js\",\"iwseV\",\"da.fc4e18d3.js\",\"eh9w8\",\"de.78dfeaf5.js\",\"3eWGu\",\"en_GB.bbd3f137.js\",\"8jVst\",\"en_ZZ.c8959eb2.js\",\"hNk7k\",\"es.eac6a84e.js\",\"arXo9\",\"fi.6157ea05.js\",\"yuLnu\",\"fr.c027e6b8.js\",\"2pQv8\",\"hu.d1cf9d34.js\",\"jGBo1\",\"it.7d2e1c00.js\",\"eUrwV\",\"ja.b326a052.js\",\"2zgDh\",\"ko.c57bedaf.js\",\"bETPT\",\"nb.779151e4.js\",\"ceBZg\",\"nl.b0aa70bf.js\",\"5STWe\",\"pl.ab437593.js\",\"EfE3i\",\"pt_BR.13398930.js\",\"hFqXA\",\"ru.d44900c6.js\",\"4ArgV\",\"sv.fde05c73.js\",\"28EDH\",\"tr.a742d791.js\",\"k3mTs\",\"th.98c92a14.js\",\"jJdZ4\",\"uk.2cdd9c4b.js\",\"eZRzs\",\"vi.e0e19052.js\",\"bLQZ9\",\"zh_TW.152ba9f0.js\",\"e0E8p\",\"zh.0de3e729.js\",\"4DYJ5\",\"cs.ae29805e.js\",\"hfFxJ\",\"da.4bac143d.js\",\"gofGr\",\"de.d8e61a4d.js\",\"aSjrK\",\"en_GB.a65deae7.js\",\"7NpX8\",\"en_ZZ.56f4bbe2.js\",\"bFU3Y\",\"es.e423bf3a.js\",\"exaJ2\",\"fi.33989446.js\",\"hcCcg\",\"fr.a66523c8.js\",\"j9KTb\",\"hu.fa3f1171.js\",\"3hjAq\",\"it.620f63c1.js\",\"2bCHJ\",\"ja.d410f0e4.js\",\"fdXnq\",\"ko.377862ae.js\",\"cItJR\",\"nb.dbba57d8.js\",\"SctKm\",\"nl.d90fd1de.js\",\"1fJz1\",\"pl.7999c76d.js\",\"9yA8o\",\"pt_BR.e534d362.js\",\"448N7\",\"ru.1fe1deae.js\",\"gBDdh\",\"sv.bc06c239.js\",\"epkdv\",\"tr.f7701f9c.js\",\"fdczG\",\"th.85d0593d.js\",\"3MGOs\",\"uk.f1a414df.js\",\"innCz\",\"vi.d3e97b33.js\",\"ebljE\",\"zh_TW.cf04c7f7.js\",\"j4dSZ\",\"zh.fb33a2b6.js\",\"b2zon\",\"loom-cross-join-nudge.3e16c1a6.js\",\"bP6pn\",\"NthUserOrientationInner.8179db53.js\",\"3Ap7H\",\"RovoAnnouncementSplashModal.6b898571.js\",\"jhQhN\",\"RovoAnnouncementSplashContainer.5584e57f.js\",\"br6Aw\",\"LightModeFrame1.88b5dbfe.gif\",\"1CT3s\",\"DarkModeFrame1.6ac03536.gif\",\"cTRon\",\"LightModeFrame2.b826bbb1.gif\",\"2zDRq\",\"DarkModeFrame2.efe28578.gif\",\"7W5z9\",\"LightModeFrame3.dbfb7a04.gif\",\"47RWT\",\"DarkModeFrame3.d087cb13.gif\",\"5CaYW\",\"video-play.924440ef.js\",\"6aY84\",\"video-pause.9effbaae.js\",\"dj3mE\",\"ExperimentPlanSelectionModal.5f9094fc.js\",\"3AFNb\",\"illustrationStandard.3fd561a4.svg\",\"c7qkT\",\"illustrationBestValue.d42ec92a.svg\",\"cYTMv\",\"illustrationBestValueDarkMode.4db8a5eb.svg\",\"eRZ4m\",\"illustrationStandardDarkMode.d9f68860.svg\",\"ktyyJ\",\"TrialFlags.e04204d3.js\",\"e7wVW\",\"ShareButton.7a457611.js\",\"85liN\",\"InspectPermissionsDialog.f567f633.js\",\"gL8bn\",\"mention.25361187.js\",\"e7ZUf\",\"mention.runtime.69dcd7a5.js\",\"h4Nf7\",\"ExternalUserLozenge.a690281d.js\",\"jbmut\",\"table.34a57928.js\",\"c831e\",\"InspectPermissionsDialog.c498f8e1.js\",\"iQ0Jm\",\"SmartButtonConfigPanel.275b3180.js\",\"eYCHi\",\"InspectPermissionsDialog.f94196df.js\",\"dMOc8\",\"projection-screen.1d8acbb5.js\",\"eJQji\",\"datasourceTableView.de1cd109.js\",\"djHM5\",\"datasourceTableView.runtime.3c43b855.js\",\"djHM5\",\"datasourceTableView.runtime.3c43b855.js\",\"e7ZUf\",\"mention.runtime.69dcd7a5.js\",\"lk4cE\",\"RequestAccessPopup.55cd43a8.js\",\"l8YLV\",\"NativeCollabComponent.025dc1ae.js\",\"9OSao\",\"WatchDialogContent.5a6b1996.js\",\"8hbZ5\",\"WatchDialogShortcut.f557792f.js\",\"iJwzY\",\"ManageWatcherDialog.eda0c90b.js\",\"1GCFv\",\"CommentsPanelWrapper.ef24f034.js\",\"36rXN\",\"MovePageDialog.606fdf89.js\",\"ltXeo\",\"PageTree.9db7bef3.js\",\"4JUnA\",\"BulkDeletePagesAction.9e7f63b8.js\",\"73HOd\",\"BulkDeletePagesAction.82f60197.js\",\"33ouG\",\"BulkDeletePagesAction.849eb5c4.js\",\"anGwD\",\"BulkArchivePagesLoader.37f0899b.js\",\"jyWy1\",\"BulkArchivePagesLoader.886f770e.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.79171d25.js\",\"aA36O\",\"ShareButton.1f35840b.js\",\"9qfB8\",\"UpdateComposer.1a4e923f.js\",\"gODOu\",\"RtPaidFeatureEducationSpotlightTarget.ba19a426.js\",\"dkv9z\",\"PageTreeAfterIcon.6792b155.js\",\"9F7vX\",\"CreateContentPopover.2624db14.js\",\"dnVDi\",\"top-nav-items.4777f0d7.js\",\"iMSgb\",\"log-in.9b553c7d.js\",\"48rvp\",\"app-switcher.41220b81.js\",\"hLjS5\",\"notification.af51f62d.js\",\"kFEyO\",\"top-nav-items.e51ea6e5.js\",\"4vxCt\",\"top-nav-items.ad3ae104.js\",\"dndbG\",\"object-preview-panel.c43a5b68.js\",\"iYF63\",\"ContentTreeOnboarding.2cce3998.js\",\"5rgzC\",\"drag-handle.73ab909e.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.e0bc4ae4.js\",\"1yVM6\",\"UpgradeEditionButton.b130a456.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.ed993859.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"6XCf4\",\"LearnMoreButton.cf13a7ea.js\",\"cEqm7\",\"ShareButton.49e571e4.js\",\"7pxAs\",\"EndUserRequestUpgradeModal.1c3723b6.js\",\"jbxHq\",\"UpdateComposer.2ca1d275.js\",\"gy5DL\",\"GlobalCreateContentPopoverMenu.00c80b90.js\",\"282rq\",\"FullPageEditorComponent.57ce4efb.js\",\"iAqyW\",\"ai-generative-text.a87325fb.js\",\"jOdEL\",\"CommentEditor.9a2619f2.js\",\"np2ZB\",\"NonMasteredUserModal.bf5eb13e.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"4byV5\",\"is-supported.734459d7.js\",\"lwKXH\",\"is-supported.1cce24bb.js\",\"btYwu\",\"esm.b69bbb04.js\",\"9a2oY\",\"home.c75a599b.js\",\"1okAQ\",\"ai-generative-chapters.ac931bcf.js\",\"28l1x\",\"esm.add861d6.js\",\"wIOhQ\",\"esm.778966b6.js\",\"ffqKi\",\"cross.20361d15.js\",\"4drdS\",\"paint-palette.c083dcd8.js\",\"jle6Z\",\"premium.3f265b33.js\",\"fFJCh\",\"status-success.45119d42.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"hU8F9\",\"LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png\",\"fTxJf\",\"LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png\",\"7QQL7\",\"GlobalCreateContentPopoverMenu.100c4ab9.js\",\"kiDFE\",\"CreateSpaceMenuItem.9436ff75.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.d511552e.js\",\"3tVyh\",\"CreateSpacePlusButton.c46b6504.js\",\"4hsy8\",\"GlobalCreateContentPopoverMenu.4369a442.js\",\"BgBDS\",\"Racecar.f378b1ee.svg\",\"fYB23\",\"GlobalCreateContentPopoverMenu.7e8c3f82.js\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"eJgN2\",\"WhiteboardsPaywallV2.5dd554e3.svg\",\"dk0NC\",\"WhiteboardsPaywallDarkV2.e9c25635.svg\",\"brItY\",\"CreateWithRovoSpotlightAnimationDark.886221cf.gif\",\"jb5iT\",\"CreateWithRovoSpotlightAnimationLight.1a1df728.gif\",\"ebWFc\",\"mention.5b53f9ab.js\",\"c9Qqc\",\"auto-dev.47f86c22.js\",\"1TK6P\",\"auto-fix.9f15d65d.js\",\"grvAy\",\"auto-review.8b18bace.js\",\"23K0q\",\"backlog-buddy.87f7f268.js\",\"3kQkj\",\"comms-crafter.8a117597.js\",\"6OXgE\",\"culture.691b57d2.js\",\"cbucA\",\"customer-insight.49b28e22.js\",\"bVhr1\",\"decision-director.3eb55db7.js\",\"kE0QC\",\"feature-flag-avatar.e97eea22.js\",\"eVFXf\",\"generic-avatar.8c3fce18.js\",\"9FhBz\",\"hire-writer.3ad651ff.js\",\"6zB8z\",\"marketing-message-maestro.554d8e73.js\",\"eENGY\",\"my-user-manual.45a1fd68.js\",\"hmlb0\",\"okr-oracle.31ef1ef2.js\",\"2NGxc\",\"ops-agent.7f918f96.js\",\"bPgcq\",\"pitch-perfector.0048c552.js\",\"31b1q\",\"product-requirement.6e475ea8.js\",\"8Lh9U\",\"release-notes.415fc7ce.js\",\"6ZzYJ\",\"research-scout.6b2d620c.js\",\"2zIbn\",\"rovo-dev.211105a6.js\",\"410SS\",\"social-media-scribe.d566b963.js\",\"z3s9q\",\"team-connection.591df503.js\",\"9gqcE\",\"workflow-builder.fe2279db.js\",\"eipnW\",\"trial-guide.026e618f.js\",\"jdAk9\",\"jsm-rovo-service-agent.277ae1b6.js\",\"fbike\",\"amplitude-agent.dcad2989.js\",\"4n4TY\",\"box-agent.31b63675.js\",\"2aX2w\",\"canva-agent.d9c04159.js\",\"dWdGk\",\"figma-agent.632f4372.js\",\"hQhwm\",\"hubspot-agent.880cc988.js\",\"7VfH7\",\"intercom-agent.a4b26f0f.js\",\"aJ4jy\",\"gamma-agent.e4d57944.js\",\"4AOh0\",\"lovable-agent.23d4d02c.js\",\"i87P0\",\"replit-agent.67c70ceb.js\",\"aLqH7\",\"rovo-agent.30b6a052.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.ed993859.js\",\"fQKYr\",\"ConfluenceSmartCreationModal.3b9f4817.js\",\"6KGrg\",\"EmojiComponent.f9f00dfa.js\",\"4izLy\",\"NativeCollabComponent.b43bfa9b.js\",\"ajMch\",\"16.0a8aa9c5.js\",\"k7MRD\",\"showFeedbackFlag.6ca451c6.js\",\"6GYDO\",\"showFeedbackFlag.6a44fbb1.js\",\"frhR0\",\"main.3cc72814.js\",\"LQeCh\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"9gDvs\",\"accessibility.5564f20e.svg\",\"f4pjt\",\"award.214f8776.svg\",\"1A7In\",\"calendar.b3d986a4.svg\",\"hbmJV\",\"checklist.73c2b414.svg\",\"dfz72\",\"community.e0696574.svg\",\"8iDBX\",\"customer.b92e93e7.svg\",\"g9qwo\",\"develop.57b4f578.svg\",\"5MnfW\",\"flowchart.a71ff7c1.svg\",\"92hcC\",\"guidelines.997e35c4.svg\",\"YpFw7\",\"hire-writer.de7ada5b.svg\",\"hPfyy\",\"icons-gears.bfd13e5a.svg\",\"4d6gC\",\"icons-people.f158a567.svg\",\"ckHEC\",\"illustrations.98e8bf43.svg\",\"iXa6x\",\"lightbulb.e4ffc69c.svg\",\"lA2m1\",\"marketing.2c92f054.svg\",\"9DSi1\",\"onboarding.43d000af.svg\",\"69pz5\",\"project-management.8376933a.svg\",\"bFaEu\",\"release-phases.4229641f.svg\",\"4HRl6\",\"resilience.4a0de1ce.svg\",\"kyaih\",\"system-of-work.579d0af3.svg\",\"avXjM\",\"tips.695c0031.svg\",\"g7RCN\",\"trust.ae24e421.svg\",\"klZVQ\",\"user-testing.1d397bb2.svg\",\"aSfft\",\"vision-values.6d647ce6.svg\",\"bDavb\",\"volunteering.f0465fb3.svg\",\"7iOBS\",\"ConfluenceCreateIllustrationLight.e6af8be5.svg\",\"gNGuh\",\"ConfluenceCreateIllustrationDark.6237fca1.svg\",\"hmO43\",\"ConfluenceCreateLiveDocIllustrationLight.99d6c903.svg\",\"c6etH\",\"ConfluenceCreateLiveDocIllustrationDark.51b6352d.svg\",\"huXHI\",\"ConfluenceCreateWhiteboardIllustrationLight.2998fbe7.svg\",\"7nSXT\",\"ConfluenceCreateWhiteboardIllustrationDark.c626a57e.svg\",\"4nraY\",\"ConfluenceCreateDatabaseIllustrationLight.8adb0acc.svg\",\"iyInC\",\"ConfluenceCreateDatabaseIllustrationDark.1e3e5bc5.svg\",\"deasZ\",\"ConfluenceCreateSlidesIllustrationLight.c1a17705.svg\",\"2YEIo\",\"ConfluenceCreateSlidesIllustrationDark.2a16aee2.svg\",\"bgHzk\",\"ConversationAssistant.74545bc8.js\",\"7Vmxp\",\"table.21c55c6c.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.d405e36f.js\",\"7ixUU\",\"datasourceTableView.156d3db8.js\",\"6cVEd\",\"fire-event.25b14310.js\",\"eO0qk\",\"datasourceTableView.53315165.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"hoPZ9\",\"cs.01c4aeef.js\",\"gyXEE\",\"cs.54a9e612.js\",\"i9sd0\",\"cs.83fe13f2.js\",\"4Mixi\",\"cs.cbb5fe34.js\",\"2Fu3d\",\"da.b3c43adf.js\",\"1Mp9N\",\"da.d49841ed.js\",\"aNg21\",\"da.b249e892.js\",\"cjveN\",\"da.835212d1.js\",\"eJgH8\",\"de.18a0cac9.js\",\"dBb6q\",\"de.999b5c94.js\",\"YEGhv\",\"de.a948c0e4.js\",\"8XGJb\",\"de.a2ec1619.js\",\"2YffH\",\"en.8b800a66.js\",\"7Lkvk\",\"en_GB.5b3f9447.js\",\"2RQvP\",\"en_GB.4a59edc0.js\",\"d8WL7\",\"en-GB.6eb7e174.js\",\"hdvZr\",\"en_GB.702092de.js\",\"5FaEJ\",\"en_ZZ.c200c5a5.js\",\"cukQS\",\"en_ZZ.f589829f.js\",\"j5F5K\",\"en-ZZ.d9e12de3.js\",\"4ViGN\",\"en_ZZ.bb1eba3d.js\",\"9yemY\",\"es.1fd9a8d7.js\",\"3CucM\",\"es.b941d673.js\",\"dXu4x\",\"es.41270b03.js\",\"32vlK\",\"es.ac31b31a.js\",\"5IaSN\",\"et.85314bc3.js\",\"34YSq\",\"et.c555b67d.js\",\"l2LZP\",\"fi.f2b93226.js\",\"lp8Wm\",\"fi.7854ba62.js\",\"18TX5\",\"fi.63c8473d.js\",\"bjoGV\",\"fi.1e513850.js\",\"35Ssm\",\"fr.68076243.js\",\"cHWSM\",\"fr.456a53ca.js\",\"9Cdzw\",\"fr.38e41dc4.js\",\"8oiz7\",\"fr.6f53d7a9.js\",\"ik6u5\",\"hu.f774ead6.js\",\"b37xN\",\"hu.cffd8ff3.js\",\"guNAg\",\"hu.a8370dba.js\",\"hFxmj\",\"hu.cd9b6b61.js\",\"fModo\",\"is.f1385f26.js\",\"Vt6S9\",\"it.8e36240d.js\",\"7PjNK\",\"it.ce73937a.js\",\"cM3gY\",\"it.e238f206.js\",\"BXOZB\",\"it.99220f36.js\",\"9GZ76\",\"ja.41bf7f70.js\",\"ktSfi\",\"ja.cd9869f4.js\",\"6yRq3\",\"ja.8644f388.js\",\"9Xiuh\",\"ja.82009b49.js\",\"4sOIV\",\"ko.afbb0641.js\",\"iouLY\",\"ko.77a2b852.js\",\"cft22\",\"ko.9e01f5a3.js\",\"7Odo3\",\"ko.f8696b38.js\",\"QTjdE\",\"nb.a10f0dc8.js\",\"hPZE5\",\"nb.bc3bab80.js\",\"gctEz\",\"nb.d9227ce7.js\",\"4VkvT\",\"nb.7fc4a303.js\",\"hrf1M\",\"nl.d2f451f9.js\",\"dzIm8\",\"nl.736c884e.js\",\"9PPH7\",\"nl.02f172dd.js\",\"g5qJV\",\"nl.27391c7e.js\",\"lsloj\",\"pl.4d749ae5.js\",\"jqwnR\",\"pl.aa78124e.js\",\"1y1eN\",\"pl.5845746c.js\",\"dPa6p\",\"pl.39ca0fea.js\",\"iRKhU\",\"pt_BR.fc377609.js\",\"bGhLc\",\"pt_BR.69377af0.js\",\"e8jpx\",\"pt-BR.c74473c0.js\",\"iG4uh\",\"pt_BR.b57aad22.js\",\"aGECO\",\"pt_PT.791ee0ca.js\",\"aOdaf\",\"ro.a3ed0d18.js\",\"6tWAg\",\"ro.9b0188fa.js\",\"aEAsN\",\"ru.6b1099ba.js\",\"9v6ER\",\"ru.ad0811e9.js\",\"fjbzp\",\"ru.303545b4.js\",\"9tVE8\",\"ru.65c56da2.js\",\"5WkxF\",\"sk.627f667c.js\",\"l6YHr\",\"sv.a4339ae3.js\",\"8Mz40\",\"sv.e48df96b.js\",\"1pFHs\",\"sv.1292df49.js\",\"6UAlo\",\"sv.575cc5b8.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"77dzh\",\"tr.40a5495f.js\",\"6NHX3\",\"tr.509cc515.js\",\"d0Fxy\",\"tr.2e975cd5.js\",\"9Yw4z\",\"tr.fb23115c.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"afU9w\",\"zh_TW.11a3f2f4.js\",\"hF4v3\",\"zh_TW.2ab7e2a2.js\",\"kKXTS\",\"zh-TW.9278becf.js\",\"ia9y3\",\"zh_TW.6efc768f.js\",\"7iCpI\",\"zh.c7ae9176.js\",\"1Tuyb\",\"zh.1e8977fa.js\",\"7sItg\",\"zh-CN.cd68d9a8.js\",\"15ncj\",\"zh.f634978a.js\",\"2lsX7\",\"main.33e42dd9.js\",\"h05Zl\",\"ufo.1597da7c.js\",\"5a167\",\"scheduler-polyfill.ca4ea44c.js\",\"jYGxH\",\"th.979bffc6.js\",\"czAFw\",\"tr.681a53e9.js\",\"c0Efy\",\"uk.94c09e9c.js\",\"dKBuH\",\"vi.58f3aadb.js\",\"2MGzj\",\"RovoLoadingGif.5cc45056.js\",\"ha91h\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"daJBG\",\"Remix-Illustration.7b8c03b3.svg\",\"l2SMx\",\"area-chart.8ac58d94.svg\",\"hmlWp\",\"bar-chart.5de1ce74.svg\",\"29sjD\",\"flip-cards.5fb66057.svg\",\"2M88p\",\"flowchart.b8ace18f.svg\",\"aDfhy\",\"funnel-chart.ac73c04e.svg\",\"7fKyJ\",\"gantt-chart.0cee2e12.svg\",\"dliHN\",\"geographical-map.b31d426b.svg\",\"hnqZb\",\"line-chart.a1760cb5.svg\",\"8o3st\",\"mindmap.95e6528e.svg\",\"7gGyC\",\"modern.81fb2fee.svg\",\"9JEVr\",\"org-chart.54763d4b.svg\",\"4qyHi\",\"pie-chart.81bd3483.svg\",\"6vuyw\",\"quadrant.d97460b3.svg\",\"idqTi\",\"sketch.ea1ec5b1.svg\",\"aBVBM\",\"timeline.f0bf7758.svg\",\"4U7Xh\",\"treemap.3fccabb5.svg\",\"gQXHN\",\"chart-icon-dark.ca77575e.svg\",\"95jYl\",\"diagram-icon-dark.3f4564aa.svg\",\"aUt3g\",\"infographic-dark.f9711bcb.svg\",\"8k7yp\",\"visual-aid-dark.4d0ae5ae.svg\",\"h6xCn\",\"chart-icon.a14be180.svg\",\"9edlo\",\"diagram-icon.695c35c3.svg\",\"fWhdP\",\"infographic-light.59c85d21.svg\",\"eSCPY\",\"visual-aid.4cbe3ad7.svg\",\"iraZ1\",\"react-markdown.d0df5225.js\",\"avRkh\",\"ReadingAidsPopup.785d908b.js\",\"dP7ao\",\"sha256SimpleHasher.e5e9154e.js\",\"77ceh\",\"definition-popup-content.bcad276c.js\",\"jY21r\",\"CommentEditor.8ee16eaf.js\",\"37ldp\",\"block.6cda4763.js\",\"7PMju\",\"refractor.cdd23fac.js\",\"3JSgG\",\"panel.d4686456.js\",\"3SmkN\",\"page.5c0060d7.js\",\"8MfZE\",\"component-lazy.a0bbb215.js\",\"855o0\",\"component-lazy.runtime.54a51d0d.js\",\"4SCW2\",\"component-lazy.0f616194.js\",\"6iz6l\",\"component-lazy.runtime.92e553f0.js\",\"9ldRJ\",\"render.898330c1.js\",\"3Zfzp\",\"ShareButton.c4e80b4e.js\",\"9wzNh\",\"CommentEditor.0cf1ed6b.js\",\"cD6Zr\",\"FullPageEditorComponent.e01c4d30.js\",\"43bfx\",\"FullPageEditorComponent.41b618cc.js\",\"k8QRJ\",\"FullPageEditorComponent.runtime.a9b2d72f.js\",\"kbRvk\",\"UpdateComposer.562e3dc9.js\",\"eBRUf\",\"GoalPanel.8e9e1448.js\",\"c0JsV\",\"link-picker.7572fdc3.js\",\"h9Ed7\",\"GoalPanel.7a095c1f.js\",\"hyzoX\",\"ProjectPanel.55dbfb0d.js\",\"lVO3w\",\"ProjectPanel.d08ffa56.js\",\"jnkIk\",\"TeamProfileCard.2bd99dce.js\",\"iNmaF\",\"ProjectPanel.0b5c8cdf.js\",\"7BRMY\",\"TeamProfileCardEntryPoint.0bac9202.js\",\"7NSxP\",\"TeamProfileCardEntryPoint.2a0176e2.js\",\"1gGaH\",\"EntryPointComponent.04e9303c.js\",\"iqTGf\",\"GoalPanel.e1a6e8a4.js\",\"7jsQp\",\"EntryPointComponent.43ce27a1.js\",\"9evbL\",\"TeamAppTile.265b8d3b.svg\",\"4vB0j\",\"TeamProfileCardEntryPoint.41eda19a.js\",\"9yT7Z\",\"ConfluenceIcon.3b027e05.svg\",\"8UdN7\",\"JiraIcon.a06d5f95.svg\",\"2Wuv3\",\"JiraProjectDiscovery.556db745.svg\",\"Q5mZp\",\"JiraServiceManagement.0b0134a3.svg\",\"32rDq\",\"LoomIcon.8c0f7a38.svg\",\"hfT7k\",\"disconnect-dialog.cde8ca83.js\",\"2cvOU\",\"NoProductAccess.a65d0283.svg\",\"5WqHI\",\"TeamProfileCardEntryPoint.1009059e.js\",\"hZtKG\",\"team-preview-panel.ec44aa14.js\",\"bxrdv\",\"definition-popup-content.d74a411d.js\",\"gQllS\",\"definition-popup-content.runtime.98083c14.js\",\"9CYct\",\"definition-popup-content.b91e3293.js\",\"fw9bs\",\"error-state-image.823f6961.png\",\"awWN9\",\"definition-popup-content.bea247fa.js\",\"6mHrv\",\"definition-popup-content.24c2b797.js\",\"eEyVs\",\"book-with-bookmark.f202cd02.js\",\"iDB1L\",\"pen.ff9dabea.js\",\"855o0\",\"component-lazy.runtime.54a51d0d.js\",\"6iz6l\",\"component-lazy.runtime.92e553f0.js\",\"k8QRJ\",\"FullPageEditorComponent.runtime.a9b2d72f.js\",\"gQllS\",\"definition-popup-content.runtime.98083c14.js\",\"aGWeM\",\"PageContentRendererFabric.f7cb85f8.js\",\"hQiKQ\",\"generative-indicator.56083120.svg\",\"4Viii\",\"compass.047fd7a8.js\",\"lRtGG\",\"dashboard.839aaa25.js\",\"1Ll72\",\"priority-high.b22fed99.js\",\"fiOV9\",\"target.6e9bf35f.js\",\"bzCep\",\"SBSIntegration.7cd68110.js\",\"ayspZ\",\"ui.9f5f9a9d.js\",\"aWHeV\",\"rovo-mobile-app-onelink.4e56e554.svg\",\"2upmw\",\"scorecard-illustration.af333c78.svg\",\"5m8Kg\",\"analyze-icon.5c4c7ecb.svg\",\"b2eNj\",\"brainstorm-icon.f24d96f2.svg\",\"4ofWJ\",\"create-icon.59c93a6c.svg\",\"jdeyK\",\"execute-icon.d7c359b6.svg\",\"5faYL\",\"find-icon.63225fe6.svg\",\"80D6g\",\"general-prompt-icon.5618909f.svg\",\"lPxCc\",\"learn-icon.7e0ca0d6.svg\",\"aDBGk\",\"review-icon.7da7ded4.svg\",\"grAf6\",\"summarize-icon.5a91c5af.svg\",\"9wrpL\",\"no-results.db2e9229.svg\",\"8HdRH\",\"build-icon-no-prompts.73453fad.svg\",\"5UFNX\",\"favorites-empty.0cc258ba.svg\",\"3GB1F\",\"conversation-assistant-viz.908cc0ca.js\",\"slRZz\",\"charts.a73287fe.js\",\"JEQyV\",\"GoalPanel.d0fab6db.js\",\"8rQw6\",\"GoalPanel.e5654bb8.js\",\"2lXdj\",\"ar_eg.e74e93c9.js\",\"2H6BH\",\"ar_sy.16217f7e.js\",\"1j3A9\",\"ca_es.eb8d0468.js\",\"8ELMd\",\"cs_cz.9ca8d9aa.js\",\"5ALC0\",\"da_dk.7091ce51.js\",\"7oMuf\",\"de_ch.6c483cf6.js\",\"hBItI\",\"de_de.49522ed5.js\",\"3zYDH\",\"en_ca.717c6ec5.js\",\"hi9pI\",\"en_gb.76cea72d.js\",\"8OGVq\",\"es_es.52a5f555.js\",\"ij0p6\",\"es_mx.33f465e0.js\",\"l29JQ\",\"fa_ir.e3f174da.js\",\"29bWW\",\"fi_fi.595149ed.js\",\"74PaE\",\"fr_ca.ec65573b.js\",\"hC1Zo\",\"fr_fr.ff1b561a.js\",\"hffn3\",\"he_il.849616c4.js\",\"c6c8y\",\"hr_hr.5b7dcce2.js\",\"j6K7h\",\"hu_hu.9702a641.js\",\"2JSRd\",\"it_it.fcc08681.js\",\"dDrYz\",\"ja_jp.c7e5ff58.js\",\"9iUe5\",\"ko_kr.dff01048.js\",\"03VCX\",\"mk_mk.72323650.js\",\"94jI9\",\"nb_no.2b482e2a.js\",\"9wRAm\",\"nl_be.4ee74165.js\",\"63xZi\",\"nl_nl.56145100.js\",\"dWMDu\",\"pl_pl.f2b9eb09.js\",\"bL1lE\",\"pt_br.372d1d14.js\",\"cnYSq\",\"ru_ru.77abe94b.js\",\"eWmQV\",\"sv_se.81a6e5bb.js\",\"3lUR2\",\"tr_tr.bea13a15.js\",\"kNkrq\",\"uk_ua.107662e3.js\",\"hGhT5\",\"zh_cn.d35ecbd8.js\",\"5VuXb\",\"zh_tw.18f55fa7.js\",\"5TD4G\",\"charts.625f2652.js\",\"7sx4A\",\"charts.c7fc67ff.js\",\"1iNFh\",\"charts.09d181ba.js\",\"9LUXP\",\"schema.1d37be41.js\",\"9WCxa\",\"lumina.bd8e9e14.js\",\"accBy\",\"default-fallback-icon.f348cee4.svg\",\"jfCh6\",\"rovo.b06223c6.png\",\"1RYoS\",\"AgentVersionPickerInternal.9e904138.js\",\"7rHnm\",\"rovo-chat-bubbles.ad8ad13a.svg\",\"2SwYm\",\"deep-research-icon-dark-mode.184ef24b.svg\",\"aSjVK\",\"deep-research-icon-light-mode.626661c3.svg\",\"ixTAZ\",\"text-field.3fa52048.js\",\"bvkpZ\",\"text-area.732a8a35.js\",\"e3d45\",\"date-time-picker.0ac3a6a9.js\",\"d34hg\",\"gic-anywhere.b46e9f5a.js\",\"2O2Xv\",\"gic-anywhere.94a5f3d5.js\",\"anP9P\",\"error.5fbc7fe9.png\",\"lHACy\",\"CommentEditor.325700f6.js\",\"gvJDI\",\"generic-issue-type-icon.b13acfc5.svg\",\"i7J2B\",\"avatar-with-arrow-darkmode.d9464bf1.svg\",\"2FbWf\",\"avatar-with-arrow.71e68580.svg\",\"3Xxws\",\"avatar-with-lock-darkmode.39948dbb.svg\",\"85zTu\",\"avatar-with-lock.b0750eee.svg\",\"girkx\",\"pencilled-field-with-arrow-darkmode.9a09e770.svg\",\"dCfoG\",\"pencilled-field-with-arrow.6615a67d.svg\",\"dG1sE\",\"text-field-with-lock-darkmode.6b00710c.svg\",\"jQD4g\",\"text-field-with-lock.548927e7.svg\",\"hZ3Uy\",\"text-field-with-tick-darkmode.49503976.svg\",\"h1tvj\",\"text-field-with-tick.9650a889.svg\",\"lsUsV\",\"ExecutePythonRenderer.83a802de.js\",\"8jz4U\",\"mcp-server-tools.48f91f40.js\",\"gxlhk\",\"insight-link-card.f2b34dec.js\",\"koZHn\",\"insight-profile-group.a181780d.js\",\"jALB7\",\"database-icon.af3511fd.svg\",\"aLbrw\",\"live-docs-icon.5595b5be.svg\",\"fe7gr\",\"page-icon.4dd78b86.svg\",\"cknJE\",\"preview-card-database-header.8549ac7f.svg\",\"gMvyv\",\"preview-card-page-header.8639e9c6.svg\",\"45ydb\",\"preview-card-slides-header.a6094606.svg\",\"6p1RF\",\"preview-card-whiteboard-header.a8b554de.svg\",\"1PP43\",\"slides-icon.ba1f1ba9.svg\",\"fuzt0\",\"whiteboard-icon.552d11f4.svg\",\"5Vin3\",\"gic-modal.8e58cafb.js\",\"3Fz2H\",\"GoalPanel.aaf2277f.js\",\"5Jsn3\",\"preview-card-survey-header.fded201f.svg\",\"3knTu\",\"light-version.6420440b.js\",\"drlw9\",\"Rovo-Growth.a6bc0c17.gif\",\"8h7WZ\",\"dark-version.767ba474.js\",\"9eO7r\",\"Rovo-Growth-Dark-Mode.b8619563.gif\",\"jQ7iC\",\"break-down-complex-issues-icon-dark-mode.3637919d.svg\",\"dluAX\",\"break-down-complex-issues-icon-light-mode.e8413fb5.svg\",\"6eL5q\",\"catchup-after-time-away-icon-dark-mode.f2e7a9cc.svg\",\"px5Rh\",\"catchup-after-time-away-icon-light-mode.b504f053.svg\",\"lTTCt\",\"create-issue-icon-dark-mode.75867f58.svg\",\"f4RDh\",\"create-issue-icon-light-mode.69e10720.svg\",\"6f9GG\",\"draft-helpful-comments-or-updates-icon-dark-mode.5795c228.svg\",\"cYCEg\",\"draft-helpful-comments-or-updates-icon-light-mode.3c50255e.svg\",\"5uq7r\",\"make-my-issues-clearer-icon-dark-mode.9e7e9a04.svg\",\"jXQMa\",\"make-my-issues-clearer-icon-light-mode.34de1b99.svg\",\"6OJV3\",\"share-my-work-with-stakeholders-icon-dark-mode.d3e80c8a.svg\",\"hRPth\",\"share-my-work-with-stakeholders-icon-light-mode.5035c548.svg\",\"lXkAL\",\"InformationModal.9762559d.js\",\"2xz6W\",\"feedback-flag.66cb31f5.js\",\"lc53W\",\"local-frontend-components.c3c51c92.js\",\"d4ByE\",\"cs.4747be9f.js\",\"5hSoy\",\"da.c28f2096.js\",\"7VsjH\",\"de.12b0866f.js\",\"a268B\",\"en_GB.b8092c16.js\",\"lhSi1\",\"en_ZZ.b69df8a1.js\",\"ft9Ll\",\"es.d684b29d.js\",\"jTa87\",\"fi.0e346fb1.js\",\"aNiGa\",\"fr.744480ea.js\",\"4r8Lc\",\"hr.143bed07.js\",\"hgY73\",\"hu.93fdcc96.js\",\"dlCkw\",\"it.15982c3d.js\",\"l9GjK\",\"ja.bde875c6.js\",\"fz30M\",\"ko.fb33a670.js\",\"kALI0\",\"nb.8e7470f4.js\",\"JRBbC\",\"pl.cc5df515.js\",\"9eERo\",\"pt_BR.4e2e0d40.js\",\"9kBhC\",\"ru.235eb619.js\",\"bzIZv\",\"sl.0b5a0129.js\",\"ab9gs\",\"sr_RS.7487407b.js\",\"awEHL\",\"sr_YR.54bb4a07.js\",\"d0TBI\",\"sv.d37eccea.js\",\"44Tsr\",\"th.4d8475b2.js\",\"52Fkw\",\"tr.4ea1bdea.js\",\"15Ksq\",\"uk.bc3bafc9.js\",\"7uvuw\",\"vi.d249824b.js\",\"8j70M\",\"zh_TW.f52624f5.js\",\"7d6QX\",\"zh.92124f88.js\",\"03aeW\",\"en_GB.0ccf7aa9.js\",\"6nK39\",\"th.e2448a24.js\",\"hWNfo\",\"tr.5e69c2fc.js\",\"8UuQQ\",\"uk.11b615ac.js\",\"6BkMx\",\"vi.352470f3.js\",\"ivmlR\",\"memory-disabled-illustration-dark.c01b3c29.svg\",\"7eY0a\",\"memory-disabled-illustration.efaa5f92.svg\",\"6WXM9\",\"memory-empty-illustration-dark.a8b58040.svg\",\"2vldX\",\"memory-empty-illustration.1df2a423.svg\",\"9xFsB\",\"memory-list-error.d375feb8.svg\",\"cU3hB\",\"smart-creation-wrapper.7512c194.js\",\"7Se0v\",\"smart-creation-wrapper.1e5aefb1.js\",\"7iXXy\",\"loading.27664d5c.gif\",\"lPsQk\",\"error-smart-create-icon.94df62fb.svg\",\"hFXeG\",\"main.0462ba49.js\",\"jn9xB\",\"Create-with-Rovo-Loading-Dark-Mode.07403868.gif\",\"81ouS\",\"Create-with-Rovo-Loading-Light-Mode.41a65ca6.gif\",\"lbiHc\",\"database-drafts-icon.3feeafba.png\",\"kroVc\",\"docs-drafts-icon.89c35078.png\",\"jG9WP\",\"whiteboard-drafts-icon.1347e699.png\",\"bYmo7\",\"smart-creation-wrapper.21991b70.js\",\"hshEG\",\"modal.1225df97.js\",\"3mmdI\",\"modal.a41877d0.js\",\"b2FtX\",\"browse-agents.51f41b9a.js\",\"8pDNY\",\"browse-agents.813f4ffd.js\",\"3EXzu\",\"render.12f122cf.js\",\"dUz9k\",\"FullPageEditorComponent.f3f0c85c.js\",\"eBY1U\",\"FullPageEditorComponent.runtime.1f482d8a.js\",\"hfoh5\",\"FullPageEditorComponent.65a2089e.js\",\"49cor\",\"agent-section.dbe9165d.js\",\"c8igH\",\"UpdateComposer.3da4a505.js\",\"3fdRd\",\"recommended-agents-preloader.b301da75.js\",\"1yrlK\",\"assets.a36da6b7.js\",\"czqcb\",\"chart-bar-line.30aba5fa.js\",\"8vVzT\",\"chart-pie.4e8d5564.js\",\"hpUn4\",\"plan.accf305e.js\",\"l4YAS\",\"project-status.e6d456e7.js\",\"6HxBR\",\"merge-success.ee5b4447.js\",\"4rKYa\",\"person-added.23b03669.js\",\"8Qv5g\",\"transition.dc10ff19.js\",\"eF7Ol\",\"talent.3167265e.js\",\"3TFqP\",\"form.ca6bb7f6.js\",\"334w0\",\"ticket.4ed0e792.js\",\"2ABJz\",\"alert.59831ff5.js\",\"cSj9q\",\"pulse.e6f59a11.js\",\"9f5Sw\",\"text-lengthen.75abb5d6.js\",\"dYRAy\",\"ai-generative-cleanup.e82a44da.js\",\"euJgP\",\"preview-bg.12045916.svg\",\"2fk6g\",\"16.54cd560a.js\",\"72780\",\"24.6148855e.js\",\"3M4Om\",\"24.8ce41ca4.js\",\"3QZdB\",\"24.ff51bea3.js\",\"hszIA\",\"24.2e0800d1.js\",\"4jPsO\",\"24.49c3df9a.js\",\"kknf5\",\"16.0e4763bf.js\",\"8059b\",\"16.7a072357.js\",\"3wmvj\",\"16.3a0a4f53.js\",\"6BeQr\",\"16.1ca294db.js\",\"hPalR\",\"16.3dfc4282.js\",\"d4u0p\",\"CommentEditor.47b90a92.js\",\"1GvGi\",\"CommentEditor.runtime.87fff718.js\",\"6cnH1\",\"CommentEditor.378bb4ea.js\",\"i1up4\",\"CommentEditor.60bfd1ff.js\",\"1P7J4\",\"FullPageEditorComponent.ab0b0cf7.js\",\"6kOJQ\",\"FullPageEditorComponent.82456b2c.js\",\"jODl6\",\"ConversationAssistant.39d312d5.js\",\"bWQZc\",\"3p-product-configs.99d58c6a.js\",\"6XaQi\",\"post-office-placement-remote.1b2f105a.js\",\"a6XkF\",\"ShareAndRestrictDialog.00218935.js\",\"6QHHT\",\"ShareAndRestrictDialog.runtime.1cd79f21.js\",\"itWY8\",\"post-office-placement-remote.f42fc9b4.js\",\"ic26z\",\"ShareAndRestrictDialog.1f88c734.js\",\"6QHHT\",\"ShareAndRestrictDialog.runtime.1cd79f21.js\",\"397zr\",\"conversation-assistant-auto-suggest.dd37501a.js\",\"j6d30\",\"ConversationAssistant.ea722edd.js\",\"7wimf\",\"main.79826a0c.js\",\"eBY1U\",\"FullPageEditorComponent.runtime.1f482d8a.js\",\"1GvGi\",\"CommentEditor.runtime.87fff718.js\",\"kKgDm\",\"main.04530c8c.js\",\"eKfu4\",\"main.09f1aeb8.js\",\"5tx3Z\",\"ConversationAssistant.54ad397e.js\",\"6SM2I\",\"cs.fced59d2.js\",\"ivb6v\",\"da.efd8e956.js\",\"7LTI5\",\"de.92bf7124.js\",\"hgUao\",\"en_GB.ccd34138.js\",\"j787T\",\"en_ZZ.d113c972.js\",\"aEmWg\",\"es.6dbeaf2e.js\",\"eR8Wp\",\"fi.75babc08.js\",\"72xPj\",\"fr.46a790f6.js\",\"1OOEW\",\"hr.11a83462.js\",\"jPs8I\",\"hu.065572e0.js\",\"8dbN2\",\"it.66391f2b.js\",\"i9Imr\",\"ja.b6e444b2.js\",\"kYLWR\",\"ko.ccd74e63.js\",\"lC975\",\"nb.92290c76.js\",\"jyEOm\",\"nl.1cfc5dc4.js\",\"agZBy\",\"pl.aa296ade.js\",\"i0zKK\",\"pt_BR.9268b557.js\",\"2zDhc\",\"ru.f0101ff1.js\",\"4eO7d\",\"sl.1b3b6bcd.js\",\"1Tr0G\",\"sr_RS.2f9f0304.js\",\"fGDED\",\"sr_YR.f4aec80b.js\",\"2l8tR\",\"sv.f8d2cb8e.js\",\"4JJfl\",\"th.dff0bbe3.js\",\"hYpqC\",\"tr.25362355.js\",\"cjEKg\",\"uk.49c97ab6.js\",\"faxoo\",\"vi.0294c992.js\",\"a2X8X\",\"zh_TW.0a2a8960.js\",\"4arx8\",\"zh.03e89d1a.js\",\"jTExV\",\"object-list-flyout-content.b372d1b2.js\",\"je720\",\"no-results-dark.90199792.svg\",\"5CyuG\",\"no-results-light.5ffcf568.svg\",\"cGPv6\",\"empty.72f8b026.svg\",\"9Y153\",\"starred-empty.227ae17e.svg\",\"1B7k9\",\"error-state-dark.fd22b26d.svg\",\"9Ftrm\",\"error-state-light.f4c1cfc8.svg\",\"b9XqL\",\"no-results-dark.90199792.svg\",\"d019N\",\"no-results-light.5ffcf568.svg\",\"igAEH\",\"filters-dropdown.86c29e9c.js\",\"3Bbwl\",\"filter.6126c2d3.js\",\"5jNvH\",\"object-list-flyout-content.c8dc55dd.js\",\"eC0VO\",\"content.ee57cfd6.js\",\"pHE7k\",\"customization-modal.a14efca6.js\",\"gbrgG\",\"customization-modal.b80af612.js\",\"a7nvi\",\"CreateComponent.811dbb05.js\",\"1f3yD\",\"ConversationAssistant.50a4c45a.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.375f638e.js\",\"9LW4b\",\"NativeCollabComponent.77ca4b33.js\",\"6jGZ7\",\"InProductHelpButton.38ce2769.js\",\"loo2r\",\"ContextualCreateContentPopoverMenu.00cafffb.js\",\"an06t\",\"MovePageDialog.ce305d68.js\",\"ivbae\",\"CommentsPanelFilterMenu.add9a085.js\",\"clpSH\",\"PageTreeQuickActions.3ee6488f.js\",\"13PnU\",\"QuickActionsContent.89d130f9.js\",\"bunf9\",\"Controller.fef1422d.js\",\"beH1s\",\"ShareAndRestrictDialog.665f9206.js\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.9979f0fa.js\",\"hc0i6\",\"en.8c08f35e.js\",\"15E48\",\"en_ZZ.0cfe40bf.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"k0hwN\",\"ShareToSlack.58cc40dd.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"a7O4E\",\"cs.d92af127.js\",\"kN8W3\",\"da.3fed3929.js\",\"jsrqT\",\"de.40d09f5a.js\",\"3VD9N\",\"en-GB.6371236f.js\",\"6rxzi\",\"en-US.ce0e2eef.js\",\"gXHED\",\"en-XA.8ec2c5f5.js\",\"2Dxuh\",\"en-XB.7762fee6.js\",\"dPidX\",\"en-ZZ.39fef241.js\",\"dfcvH\",\"es.19c39ccf.js\",\"7Y59F\",\"et.270b107d.js\",\"50tPJ\",\"fi.67143a7d.js\",\"9oubr\",\"fr.3b8aa128.js\",\"djRvH\",\"hr.0006b0d2.js\",\"bO0hF\",\"hu.f8e891ce.js\",\"7URpa\",\"it.a1147dd2.js\",\"eDUok\",\"ja.fd98594d.js\",\"cvBaM\",\"ko.7e839682.js\",\"2wtqZ\",\"nb.be1b0251.js\",\"gXynX\",\"nl.15e7e417.js\",\"7bhv3\",\"pl.acf1541e.js\",\"lfEaQ\",\"pt-BR.f373a4ae.js\",\"k9PEt\",\"ro.7a963cd2.js\",\"bQHVt\",\"ru.c2a03780.js\",\"3Qge6\",\"sl.088e4f31.js\",\"kRDD2\",\"sr-RS.6889204e.js\",\"4yt96\",\"sr-YR.035ee279.js\",\"klTnj\",\"sr.e0362078.js\",\"1OMwg\",\"sv.4fa58d69.js\",\"5G5Ud\",\"th.3296ec19.js\",\"52niQ\",\"tr.e664b17d.js\",\"5etrF\",\"uk.6cf01b20.js\",\"3T81s\",\"vi.f8373e62.js\",\"b7qqi\",\"zh-CN.f71cfc83.js\",\"iSnvi\",\"zh-TW.8751fa37.js\",\"dGk3x\",\"GlobalFeedbackCollector.bdf8f479.js\",\"gfIg9\",\"DarkEmptyState.9fb84b31.svg\",\"jyTL7\",\"LightEmptyState.aa88b60d.svg\",\"2i7Iv\",\"DarkError.d13c9c5b.png\",\"17ygR\",\"LightError.5b516166.png\",\"c4Kdp\",\"GeneralAccessLevelSelector.d496171f.js\",\"1TOYq\",\"CoreInvites.6f54db57.js\",\"daaDV\",\"AiInEditorModal.bea9e4ce.js\",\"a8Jk0\",\"ShareAndRestrictDialog.e276a214.js\",\"13QWg\",\"in-trial-feature-gates-banner.977e88c0.js\",\"dVLeP\",\"ShareAndRestrictDialog.95e631bb.js\",\"1yNQY\",\"CoreInvites.ad3bc5b3.js\",\"7oczk\",\"cs.8ce677a9.js\",\"e2gl6\",\"da.144bf782.js\",\"9oo3s\",\"de.8b728a39.js\",\"1ZyUV\",\"es.6e5d4e2c.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.770eedc0.js\",\"5nw5x\",\"fr.c78dff1c.js\",\"jK12s\",\"hu.6cd67457.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.11c8df23.js\",\"lyt83\",\"ja.1c0a9469.js\",\"2uvfp\",\"ko.0993836f.js\",\"4Wx8B\",\"nb.7422f506.js\",\"huTg5\",\"nl.d63f3676.js\",\"fPfEd\",\"pl.60f64046.js\",\"fTYhL\",\"pt_BR.f1b5821f.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.e13f4e36.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.0c110c42.js\",\"5ErHy\",\"tr.eb8f4d08.js\",\"jJzpI\",\"th.40dad87b.js\",\"2PvRH\",\"uk.418bc1c8.js\",\"eUGjU\",\"vi.b62f5e14.js\",\"drbCf\",\"zh_TW.61263813.js\",\"5dk6T\",\"zh.b7192b9d.js\",\"7pAFt\",\"WarningIllustration.6f86942e.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"dVJPu\",\"NativeCollabComponent.b1fb825b.js\",\"aNs2l\",\"CloseConfirmationDialog.85fc3c9a.js\",\"8mRQn\",\"GroupNotifyWarningDialog.29ae45dc.js\",\"6kgln\",\"NotifyLargeAudienceWarningDialog.d242443f.js\",\"8zXXZ\",\"AccessDetailsDialog.79abaee0.js\",\"be2Az\",\"AccessDetailsDialog.0f27cbfe.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"8cplU\",\"RestrictedAccessWarningDialog.fd8b3ad3.js\",\"5dkX4\",\"ResolveRestrictionsDialog.7bf4713d.js\",\"5w0fh\",\"OpenAccessWarningDialog.6adf24a3.js\",\"5oAgS\",\"ConfirmationDialog.3c740aad.js\",\"9RoKK\",\"RemoveAllSpecificAccessConfirmDialog.f8420943.js\",\"dedpp\",\"ShareButton.132820ec.js\",\"jrCdz\",\"Controller.b1d1f7ab.js\",\"k55bj\",\"Controller.e3757ad8.js\",\"loqJg\",\"TableOfContents.c1884293.js\",\"cUtrS\",\"WatchDialogWrapper.6e354902.js\",\"bCr24\",\"main.1e3620c1.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"bg5OF\",\"shortcut.6dd1c4df.js\",\"fLZBc\",\"QuickActionsContent.9c54bb8d.js\",\"PNyg1\",\"InlineRename.1ea8d348.js\",\"dlm6q\",\"InlineRename.b91d09b9.js\",\"2vQEy\",\"NativeCollabComponent.a64c5fc2.js\",\"1sXQt\",\"FavouriteButton.24f44155.js\",\"89b92\",\"PublishButtonWithMoreOptions.f317c6e4.js\",\"24IdC\",\"Publish-Modal-Background-Image-Light.4e795a9a.svg\",\"dXonJ\",\"Publish-Modal-Background-Image-Dark.cd843bfb.svg\",\"gZ0i8\",\"PublishHubDialog.8b1fce29.js\",\"5zDuS\",\"NativeCollabComponent.183c9821.js\",\"kLojH\",\"CommentEditor.ccd6c35d.js\",\"2F69B\",\"vendors~small-pkgs.2928d02c.js\",\"fZyYv\",\"pubsub.9cb848cc.js\",\"j8Ant\",\"PublishButtonWithMoreOptions.97ddce78.js\",\"anQQJ\",\"PublishModal.deb39d21.js\",\"kahM9\",\"PublishButtonWithMoreOptions.b58eb8ab.js\",\"6HLQW\",\"PublishButtonWithMoreOptions.6a6e5fec.js\",\"fCqMy\",\"DiscardModal.4a4f58a1.js\",\"a6uKK\",\"CancelSchedulePublishModal.ddd2c300.js\",\"4hZJd\",\"EmojiTitleSelection.069226f7.js\",\"XgRtr\",\"EmojiPicker.553c0309.js\",\"hUvv7\",\"LiveDocsDefaultIcon.97211d26.js\",\"4mgLr\",\"node.a3f57a67.js\",\"ajt6g\",\"MovePageDialog.643fc3b5.js\",\"3L1uC\",\"PageTreeErrorComponent.c676873e.js\",\"ewwba\",\"PageTreeEmptyComponent.26a5355b.js\",\"dviIw\",\"CollapsibleSection.46105151.js\",\"dhqJV\",\"FooterCreateButtons.d08d3a8f.js\",\"67Pvd\",\"ContentTreeOnboarding.c17ea4dc.js\",\"e19Zv\",\"LiveDocsIconTile.e9e5d34b.js\",\"d1QkY\",\"TreeBottomCreateButton.dd5a893f.js\",\"f9QHk\",\"TreeMonitor.94d21a8a.js\",\"fnoJZ\",\"HomepageIcon.f41b8d55.js\",\"6gau7\",\"DraftLozenge.b5057eb0.js\",\"5ppK3\",\"MovePageDialog.3a57f840.js\",\"e4XZ1\",\"MovePageDialog.5f303339.js\",\"fJ83T\",\"NativeCollabComponent.0e18d457.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.aed9b9c6.js\",\"hA2SB\",\"GroupAndUserItem.445043c0.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"j104l\",\"PageContentRendererTiny.f8673314.js\",\"hwq7s\",\"GroupAndUserItem.edcb090e.js\",\"iK31U\",\"GroupAndUserItem.c2ad504a.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"aoGyu\",\"MovePageDialog.fdb1b5f1.js\",\"6FaFk\",\"ContentTreeSearchStates.e72e9d6c.js\",\"7ZHrh\",\"SearchNoResultLight.8777776b.svg\",\"gaG2b\",\"SearchNoResultDark.50b7a17f.svg\",\"cPaXL\",\"ArchiveUpsellDialog.b3edd60b.js\",\"3uux1\",\"ArchivePagesLoader.44481b65.js\",\"8qpSy\",\"ErrorSectionMessage.702da4db.js\",\"i5EJc\",\"ErrorComponent.b01904b8.js\",\"2wJza\",\"ErrorGraphic.784b3ce3.svg\",\"42aQC\",\"ArchivePagesLoader.9a12445e.js\",\"in6Mc\",\"NoChildrenBullet.407634ad.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.8b33fc73.js\",\"7f9Fz\",\"root-component.2ecfdf2b.js\",\"4xZ5N\",\"PageQuickActionAutomationMenu.a74da07d.js\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"awXdT\",\"error.b6351f9e.svg\",\"5p0Bu\",\"PageQuickActionAutomationMenu.b87782f7.js\",\"cDlXo\",\"cs.bb7b2398.js\",\"aGqxI\",\"da.2f2eb656.js\",\"8DMgV\",\"de.d2d66f21.js\",\"3lwWF\",\"en_GB.ef04196d.js\",\"6n44e\",\"en_ZZ.0706863b.js\",\"i2lSs\",\"es.cfb981b6.js\",\"cddHY\",\"fi.b34be9f5.js\",\"2nFnK\",\"fr.9414a49e.js\",\"iMEy4\",\"hu.19dd1006.js\",\"79NWg\",\"it.5b76b6c9.js\",\"dn37Z\",\"ja.198e5ad1.js\",\"2y34H\",\"ko.a4730b26.js\",\"g8Vga\",\"nb.256e2e51.js\",\"fw5Rx\",\"nl.7df68bde.js\",\"cqxYX\",\"pl.48257922.js\",\"3Wq1f\",\"pt_BR.b0cab9c2.js\",\"ePmaE\",\"ru.f24df80d.js\",\"2PbJR\",\"sv.9362d1ff.js\",\"04oVB\",\"tr.2426a00f.js\",\"7lf25\",\"zh_TW.3e778977.js\",\"csVFP\",\"zh.453474a1.js\",\"9YGIy\",\"DeleteNestedPagesAction.af84c0ab.js\",\"iomzR\",\"DeletePageDialog.4470795d.js\",\"p4ay7\",\"CopyPageTreeContainer.82a06a12.js\",\"aiU5r\",\"CopyPageDialogContainer.c953bb3a.js\",\"aoUod\",\"MoveBlogModal.9f9759df.js\",\"23MlT\",\"RevertEditorDialog.1ccd11c2.js\",\"RU02s\",\"ConvertToLivePageDialog.7297a40e.js\",\"aS96v\",\"ResolvedInlineCommentsCounter.92e93f1e.js\",\"dxDVc\",\"UnarchivePagesLoader.7076deae.js\",\"9PeA0\",\"GrantAccessDialog.cc4adda8.js\",\"4mWJk\",\"GrantAccessFlag.7bd11ea9.js\",\"4dNRa\",\"EndOfPageRecommendation.20b7fb1e.js\",\"DerzA\",\"EditPageContainer.0e6ff67e.js\",\"fno6o\",\"RestrictionsDialogMountPoint.f58dc5ac.js\",\"inQqk\",\"RestrictionsDialog.29220974.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"69XGw\",\"InspectPermissionsEntryPoint.b222f919.js\",\"2VACG\",\"RestrictionsUpsellDialog.f58074fc.js\",\"1zoBu\",\"ChangeEditionInlineDialog.280c5338.js\",\"bfhXH\",\"RestrictionsButton.4bab5ef1.js\",\"3alGb\",\"ObjectSidebarContent.dafc0157.js\",\"geNwN\",\"ObjectSidebarPanelWrapper.f606c4a4.js\",\"geh8r\",\"AdminNavigation.d2128e98.js\",\"kBLei\",\"PersistentCollapsibleSection.8bd2674b.js\",\"5E6oP\",\"AutomationOnBoarding.048eda44.js\",\"1TfYn\",\"AutomationLight.3a471294.png\",\"5ZTDJ\",\"AutomationDark.427f07ad.png\",\"8s35j\",\"SpaceRolesLozenge.7393ed0d.js\",\"gRwQ3\",\"cash.f61073db.js\",\"830Zv\",\"HubSettingsNavigation.55b08c94.js\",\"cD5e0\",\"GlobalNavigationComponent.b4d278d2.js\",\"aGsq7\",\"companyHubItemCallback.b5311c49.js\",\"7BaJE\",\"AddFeaturesSidebarSpotlight.e2dadf46.js\",\"5KU6f\",\"GlobalAppShortcutsSection.c7cbf763.js\",\"k7TXX\",\"people-teams.537dd1e7.js\",\"KCO7t\",\"TeamProfileActivityTab.b97e298d.js\",\"48eS0\",\"cs.473760f2.js\",\"lak6L\",\"da.2148425a.js\",\"inCHL\",\"de.54943eb3.js\",\"lLx4a\",\"en.3be1be31.js\",\"auTAr\",\"en_GB.a2dc38b7.js\",\"9pxVf\",\"en_ZZ.2b03ebf2.js\",\"4cEzx\",\"es.89bc2922.js\",\"iUIL3\",\"et.8f07e723.js\",\"lADZV\",\"fi.322d3cd4.js\",\"1QHKh\",\"fr.b4f35314.js\",\"2Tjcq\",\"hu.9ecb9575.js\",\"4WVVc\",\"is.aa3b7b54.js\",\"1QNch\",\"it.e25db4e4.js\",\"jQCyA\",\"ja.0ddab2f2.js\",\"aQwae\",\"ko.e4e697cd.js\",\"cS1j1\",\"nb.753a83ee.js\",\"48pzM\",\"nl.2a2ad011.js\",\"c4a0F\",\"pl.173f9fb9.js\",\"cBmO4\",\"pt_PT.fb87e247.js\",\"9e3Ob\",\"pt_BR.5d0f712d.js\",\"7Hoje\",\"ro.6553ad3e.js\",\"4dj0m\",\"ru.14ff62d0.js\",\"j5HYK\",\"sk.89deb301.js\",\"1VsiM\",\"sv.dd2618b6.js\",\"8CqFM\",\"tr.d8a87762.js\",\"5bAmA\",\"th.0f648ee2.js\",\"i0Evx\",\"uk.9ffebeba.js\",\"j8OKz\",\"vi.77783e57.js\",\"2s1Lz\",\"zh.c8085958.js\",\"iI3rq\",\"zh_TW.94720f2d.js\",\"7MCI9\",\"people-teams.fd1f7e62.js\",\"14xAG\",\"GlobalAppShortcutsSection.8205103d.js\",\"SepNY\",\"analyticsCallbacks.d20502b2.js\",\"1cMUZ\",\"StarredContentMenu.3c3347f4.js\",\"dbIft\",\"emptyStarBox.3b01bf42.svg\",\"1ePSc\",\"StarredContentMenu.53b76ed6.js\",\"03cvv\",\"errorWarning.3a015e54.svg\",\"dvjk6\",\"noResultsDark.90199792.svg\",\"57B0v\",\"noResultsLight.5ffcf568.svg\",\"2yM8Y\",\"RecentContentMenu.285ec808.js\",\"b3B6t\",\"coffeeChat.72f8b026.svg\",\"j6Nec\",\"EditorForYouSpotlight.ecf98e2a.js\",\"9jGiN\",\"DiscoverSection.ed56aa41.js\",\"brnyq\",\"miro.cb595030.png\",\"1IPtO\",\"slack.ba8f92ff.png\",\"gSraM\",\"invision.8f2e37e4.png\",\"8b1I3\",\"google-drive.d0028a0e.png\",\"6bVkQ\",\"lucidchart.8807407a.png\",\"FBIp4\",\"TeamsAppShortcutItem.e6da9797.js\",\"borwc\",\"CustomizationModal.af855dcb.js\",\"kJG13\",\"CustomizationModal.42ca1505.js\",\"6oCkc\",\"GlobalNavigationComponent.38bfb4c2.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.e57d3ec7.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"a9w2G\",\"FullPageEditorComponent.e2a0481a.js\",\"6S3Gy\",\"marketplace.8761e365.js\",\"81eQE\",\"hashtag.01b327f2.js\",\"bwFkB\",\"GlobalNavigationComponent.7f6360a1.js\",\"2ZKtw\",\"main.66b028b8.js\",\"dFhUX\",\"invited-app-popup.4c209f23.js\",\"69GDg\",\"Home.eb3dbfc7.gif\",\"bxhxc\",\"Home-dark.b4541437.gif\",\"216TD\",\"Home-placeholder.72eb75ff.png\",\"7Bv6F\",\"Home-placeholder-dark.86521bfc.png\",\"bs8S7\",\"GlobalNavigationComponent.10c13b0c.js\",\"7JfxY\",\"SpacesDropdown.6e8dd340.js\",\"hmXd6\",\"fileCabinet.17ae0554.svg\",\"17BHA\",\"noResultsDark.90199792.svg\",\"7S3sF\",\"noResultsLight.5ffcf568.svg\",\"aYgZt\",\"SpaceNavigation.fe31c0cb.js\",\"TkY5q\",\"RtPaidFeatureEducationSpotlight.d9e5d2fb.js\",\"cJHFd\",\"Nav3SpaceNavigationContent.fed8c8ea.js\",\"kyxdN\",\"EditSpaceLogo.11057449.js\",\"gRwHT\",\"EditSpaceLogoComponent.7379cf98.js\",\"7t2Ec\",\"EditSpaceLogoGallery.83acab6e.js\",\"h2810\",\"PersistentInvitePeopleButton.741daec6.js\",\"860dT\",\"SpaceHeaderExCoOnboarding.f51007dc.js\",\"9H1r6\",\"GraphBarIcon.8122a900.js\",\"19Ali\",\"GridIcon.bf4f9a0b.js\",\"hI11K\",\"AutomationNavigation.f2f6b6cb.js\",\"4skpM\",\"AutomationChangeBoarding.11d658c8.js\",\"8xPy6\",\"SmartButtonIllustration.b4b7c8dc.png\",\"fbDZw\",\"QuestionsNavigation.b47edff5.js\",\"c0OU0\",\"QuestionsIcon.2b9be2c0.js\",\"7Qxu7\",\"TeamCalendarNavigation.d2376ea1.js\",\"aZ9pO\",\"CalendarIcon.852bd13f.js\",\"5DqrE\",\"BulkToolsNavigation.a361c3e8.js\",\"hHrTM\",\"edit-bulk.40121784.js\",\"klGUa\",\"ErrorView.cfe034a4.js\",\"j0beU\",\"EyeStrike.801ddb27.svg\",\"eWlhh\",\"Nav3SpaceApps.8eea70b5.js\",\"hs6o8\",\"SpaceAppsConfiguration.4adedb8d.js\",\"19XET\",\"render.4f16e2cd.js\",\"QDkFg\",\"sidebar-collapse.dbccbb88.js\",\"15N8O\",\"sidebar-expand.75a33394.js\",\"j4CTh\",\"tasks.4e573bd1.js\",\"iTzK7\",\"PageLayout.1ff873d7.js\",\"iTImB\",\"heart.91f6fb22.svg\",\"bl22g\",\"notes.c9738615.png\",\"lguNj\",\"chrome-icon.40414d4b.svg\",\"c4pCE\",\"rovo-icon.a638efdd.svg\",\"l5cKN\",\"twc-app-tiles.b4f04c82.svg\",\"bn3MP\",\"cs.446d71e8.js\",\"bCRQO\",\"da.f2632b81.js\",\"icPOh\",\"de.7e7ce723.js\",\"irb4K\",\"en_GB.0d8fd3bc.js\",\"3o6Po\",\"en_ZZ.91c327a7.js\",\"4LsSr\",\"es.c1c50af3.js\",\"3lxf3\",\"fi.483cf707.js\",\"2zz6F\",\"fr.8075ddc8.js\",\"37w4x\",\"hr.e280a499.js\",\"i6dLm\",\"hu.2eb734ac.js\",\"iz3iW\",\"it.6d7a2c86.js\",\"f6tHd\",\"ja.5862774c.js\",\"k6MzV\",\"ko.1faf92eb.js\",\"hcgQv\",\"nb.eb03083a.js\",\"22xh6\",\"nl.4682d2ea.js\",\"7h480\",\"pl.08d4553a.js\",\"h7DsC\",\"pt_BR.bae8b4d9.js\",\"aNE6d\",\"ru.7654c15a.js\",\"jVJD9\",\"sl.9936fba6.js\",\"4gQ48\",\"sr_RS.3808d319.js\",\"hQ8Od\",\"sr_YR.edec99aa.js\",\"lB1mG\",\"sv.9e71d2f9.js\",\"2XVrh\",\"th.c07fd198.js\",\"hZfMu\",\"tr.ff682f6d.js\",\"36gUn\",\"uk.b930fd95.js\",\"2nhsY\",\"vi.bbb670fb.js\",\"2rLcj\",\"zh.9781761d.js\",\"hja5d\",\"zh_TW.f5c7f917.js\",\"cgRYU\",\"rovo-icon.999e8c7b.png\",\"92hTI\",\"Nav3SpaceNavigationContent.ba6278d2.js\",\"1NnjK\",\"ShortcutsSection.96acdc49.js\",\"aBvTF\",\"ShortcutsDragContainer.6803cdfd.js\",\"fFddv\",\"LinkPickerWithPlugin.8f18d010.js\",\"jiFtb\",\"epic.6887d63b.js\",\"4RbVd\",\"database.7bd12ec5.js\",\"bGpE6\",\"whiteboard.e754a12f.js\",\"jg5LT\",\"root-component.82b5a22d.js\",\"kDqHr\",\"file-icon.7c0a9b34.js\",\"4HZlX\",\"chart-bar-icon.6975ba0a.js\",\"7jSfd\",\"list-bullet-icon.339b1061.js\",\"aOY32\",\"branch.82fba7e3.js\",\"6fQco\",\"commit.b8c711d2.js\",\"1MWOL\",\"pull-request.63023f87.js\",\"9wPDc\",\"code.981331a1.js\",\"lm9Lt\",\"changes.645808de.js\",\"4S1SF\",\"incident.9e4821e1.js\",\"XZauT\",\"problem.2f02311b.js\",\"9aQIt\",\"subtask.db9635e9.js\",\"5TCys\",\"SpaceViews.4e8dfc16.js\",\"aCG0y\",\"SpaceViewsErrors.ae200095.js\",\"5qLBt\",\"SearchNoResultLight.8777776b.svg\",\"6KUsM\",\"SearchNoResultDark.50b7a17f.svg\",\"1TYNY\",\"SpaceViewsCurrentViewIndicator.41f91889.js\",\"guX1n\",\"ViewMoreButton.f5ef9904.js\",\"kJLy8\",\"SpaceViewsList.c6f884d3.js\",\"6gmSt\",\"PagesItemActions.7f2c733a.js\",\"3YKnT\",\"bulkActionsChangeboardingSpotlightImage.9c36fbc8.svg\",\"fC3D2\",\"SpaceViewsMenu.155a5747.js\",\"cWvhX\",\"PageOwnershipByLineWithContributorsDropdownContent.16c510dc.js\",\"eQlG4\",\"ContentTreeSearch.aed6a9af.js\",\"cQVtz\",\"SpaceHoverPageCard.59d8d2a0.js\",\"hDNUK\",\"BlogTree.29aa612f.js\",\"9MwZi\",\"loom.96da19c1.svg\",\"73aP7\",\"microsoft-teams.4206e18c.svg\",\"2JHVU\",\"google-drive.3a58669c.svg\",\"iQqT9\",\"eyelash.6dc5a5e0.svg\",\"6qC0v\",\"connect-arrow.cec87b81.svg\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.12f4d17d.js\",\"7Ni3R\",\"GuestOnboardingModal.9112bc7c.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"hFtKc\",\"SpaceNavigationContent.f4b6fac9.js\",\"ci2h5\",\"Spaces.5611c4bd.gif\",\"gEZwe\",\"Spaces-dark.4ceec6cd.gif\",\"3XEdh\",\"Spaces-placeholder.5b3f2999.png\",\"7SqAi\",\"Spaces-placeholder-dark.1c1d1b34.png\",\"PkFdp\",\"SpaceMoreActionsMenuContent.10e76d88.js\",\"6oFhK\",\"ExternalCollaboratorsSpaceInformationMessage.fab0ba72.js\",\"c08ou\",\"CalendarsLink.3ee1308e.js\",\"8uhuz\",\"QuestionsLink.d97d6d50.js\",\"kZjBp\",\"SpaceApps.124fc662.js\",\"fSc0b\",\"Nav4CollapseReminderSpotlight.34a046a9.js\",\"9IEev\",\"PlatformNavigationComponent.98b31ed1.js\",\"5iVCs\",\"cs.6a4c25c7.js\",\"k7RZQ\",\"da.9877c37f.js\",\"9CFJc\",\"de.bb97d0fd.js\",\"3fPuK\",\"en_GB.9561a37b.js\",\"dUyEb\",\"en_ZZ.c7ec2c16.js\",\"PAD2J\",\"es.8b476d00.js\",\"GNuQo\",\"fi.625ea11d.js\",\"fvsAU\",\"fr.3c57c9b9.js\",\"h7dGJ\",\"hu.a577b1ea.js\",\"kg6sH\",\"it.bd75db28.js\",\"fqF5W\",\"ja.edd3a363.js\",\"1WNp5\",\"ko.b85ae1d4.js\",\"iHPxa\",\"nb.20c3bd75.js\",\"Qf3VH\",\"nl.573e6cdf.js\",\"79OEV\",\"pl.98acd127.js\",\"27dMt\",\"pt_BR.405f85d7.js\",\"bkVVv\",\"ru.c004cf49.js\",\"MLhYA\",\"sv.aaf78479.js\",\"ap7kW\",\"th.a4a6fd4b.js\",\"45YAR\",\"tr.b2cb22e6.js\",\"kqhVG\",\"uk.47e01bb2.js\",\"1susf\",\"vi.1184af6c.js\",\"dl3k2\",\"zh_TW.6e51a40f.js\",\"aquXY\",\"zh.f784abff.js\",\"gY1B8\",\"async.7ec71cf3.js\",\"cvXSy\",\"RightPanel.2b72a196.js\",\"aoJPa\",\"main.c8d847d6.js\",\"7AIwp\",\"alert-icon.236d7fa8.svg\",\"iOFzT\",\"HelpPanel.2c912dbf.js\",\"b3xzh\",\"LICENSES.46b052fc.js\",\"j2bbk\",\"flask.4abe7595.js\",\"1Qnbg\",\"device-mobile.e5585656.js\",\"9mBQe\",\"feed.e134a1f8.js\",\"btlgC\",\"PageLayout.c5deb1be.js\",\"3WCRn\",\"NewKeyboardShortcutsDialog.052fd57a.js\",\"4AAsh\",\"AddPersonalSpaceDialog.bace83ad.js\",\"cbb8R\",\"megaphone.ea49a10b.svg\",\"7enLt\",\"clipboard.6bbe40ee.svg\",\"irkOO\",\"nameTag.1bdcf89f.svg\",\"dJC82\",\"DeleteSpaceDialog.2d626408.js\",\"4ukY5\",\"AboutConfluenceDialog.b86b4be5.js\",\"6wPv6\",\"GiveFeedbackDialog.652e3933.js\",\"943D1\",\"ThemePopupMenu.416b29e3.js\",\"9HjCR\",\"theme-light-thumb.1c8784c4.svg\",\"75cX5\",\"theme-dark-thumb.996efaf5.svg\",\"fc8cx\",\"theme-system-thumb.a357a448.svg\",\"ezrgf\",\"ApprovalsPane.a1b2a742.js\",\"9ijrN\",\"modal.7b6f1fce.js\",\"lGcru\",\"FullPageEditorComponent.2c854731.js\",\"736as\",\"AISummaryFooter.4b86db6f.js\",\"8Sbjy\",\"FullPageEditorComponent.a25ee997.js\",\"5UCxV\",\"SelectionComponent.e74b65b3.js\",\"kWjLh\",\"PageLayout.a9e4cb25.js\",\"jZwEH\",\"ExitBranchDeploy.c9c9c03d.js\",\"3aT4s\",\"FeedbackCollectorButton.b17a90b3.js\",\"dChec\",\"spotlight.23a2e152.js\",\"fSawH\",\"SelectionComponent.332e17b5.js\",\"6tsCm\",\"PageLayout.52b4dfe0.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.5cdc7880.js\",\"lpcEN\",\"ChangeHubNameDialog.b2a051f4.js\",\"70fET\",\"hub-hero-image.d6790ccb.png\",\"1GyAj\",\"BreadcrumbsDropdownContent.1ed21ab3.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.2b5f9d84.js\",\"kUMFm\",\"PageLayout.b369478b.js\",\"lz2pE\",\"EditionAwarenessUpsell.72eabcd4.js\",\"eWCiQ\",\"standard-to-premium-modal.fe1705e5.js\",\"adH3p\",\"roadmap.beb86071.js\",\"becB8\",\"on-call.39b97377.js\",\"gjVBG\",\"devices.13a157d4.js\",\"hUapU\",\"StandardToPremiumModal.91cde684.js\",\"dNed9\",\"standard-to-premium-modal.42f73e58.js\",\"gobtw\",\"cs.f2325b58.js\",\"4XclW\",\"da.8823548e.js\",\"5FpC5\",\"de.9f8c75dc.js\",\"Z7F9W\",\"en_GB.88145e4b.js\",\"5vJlz\",\"en_ZZ.6e66d65b.js\",\"kqbLA\",\"es.ebafda9e.js\",\"2xTUv\",\"fi.e29037f1.js\",\"ke5Ak\",\"fr.c635078e.js\",\"78Xv1\",\"hu.36e2e3d5.js\",\"9WYDz\",\"it.b621bab0.js\",\"14Xp5\",\"ja.00759942.js\",\"5YZ43\",\"ko.cb3af28f.js\",\"hcAAz\",\"nb.cd8afc0a.js\",\"a3CGb\",\"nl.7356521a.js\",\"3jRvQ\",\"pl.7af8622a.js\",\"3eKFX\",\"pt_BR.24688c8c.js\",\"2cWJ7\",\"ru.b416633d.js\",\"7io6v\",\"sv.370b80d6.js\",\"bcDrQ\",\"th.aaf28806.js\",\"23xaC\",\"tr.5a5f7532.js\",\"dBkXE\",\"uk.f9026017.js\",\"fQKkM\",\"vi.09fcf459.js\",\"cXjwK\",\"zh_TW.2cb7259f.js\",\"fCfjN\",\"zh.9966cb4b.js\",\"eeaKR\",\"credit-card.39a2b6fa.js\",\"eufZR\",\"LoomCrossFlowPopupComponent.eb51d38d.js\",\"3FT39\",\"cs.b4709f80.js\",\"7QoTg\",\"da.e788fd22.js\",\"d1Lrf\",\"de.2dd434ed.js\",\"kM5GB\",\"en_GB.82797faf.js\",\"5506N\",\"en_ZZ.a7c6e9ad.js\",\"7ioy0\",\"es.a4af58eb.js\",\"kZ6zs\",\"fi.aaa32cea.js\",\"phbpE\",\"fr.0e55ec47.js\",\"6pKhl\",\"hu.8153cc96.js\",\"hzLOt\",\"it.75418871.js\",\"1M8mW\",\"ja.6ef7e39a.js\",\"eHQAY\",\"ko.36b5b8ee.js\",\"8exPB\",\"nb.9e9e6a03.js\",\"knfAP\",\"nl.dbd0c739.js\",\"ljRXP\",\"pl.7932a8db.js\",\"bEb8c\",\"pt_BR.e2f7c972.js\",\"c7JYF\",\"ru.a2b7a11a.js\",\"ari8V\",\"sv.1d81f4cf.js\",\"kfrHX\",\"th.0d215dce.js\",\"aWToy\",\"tr.9415008a.js\",\"4ns5x\",\"uk.baa17c6e.js\",\"7bfAn\",\"vi.26b5754b.js\",\"gftgT\",\"zh_TW.b791e5b1.js\",\"6YVlG\",\"zh.ccb62d88.js\",\"3GIo9\",\"EditionAwarenessUpsell.23d9e94b.js\",\"9CRBg\",\"StandardToPremiumModal.2c566daf.js\",\"8H6xE\",\"EditionAwareness.2286ff7b.js\",\"1AVLS\",\"automation-free-limit-modal.c9bea47a.js\",\"1Bzn5\",\"breached-icon-dark-mode.c76c5af4.svg\",\"4li5B\",\"breached-icon.604210d1.svg\",\"5Hb8k\",\"gestural-line-dark-mode.0238cd16.svg\",\"fKxeV\",\"gestural-line.c0eb7c9f.svg\",\"7REXs\",\"automation-danger-icon.9e7c0e3a.svg\",\"7NqPm\",\"automation-warning-icon.0d3ef917.svg\",\"aMOuo\",\"collection-add-payment-details-popup.28787161.js\",\"9gHNl\",\"twc-popup-background-dark.0f701da2.svg\",\"2l8ah\",\"twc-popup-background-light.30b1cc68.svg\",\"99wAt\",\"collection-change-plan-popup.6459b735.js\",\"dGvEg\",\"feature-onboarding-modal.e007a31e.js\",\"39fCS\",\"background-dark.a3b81b65.svg\",\"hlyBg\",\"background.335ae0da.svg\",\"ltJpU\",\"blue-box.4faddac8.svg\",\"lq3Sl\",\"free-choose-your-edition-modal.bf834c4e.js\",\"iI6Q4\",\"free-to-standard-modal.1d33b20e.js\",\"2zp5o\",\"background-dark.46d9946a.svg\",\"eGZ7X\",\"background-light.c76a8e81.svg\",\"2kbQr\",\"discovery-background-dark.73b58e40.svg\",\"8LjMq\",\"discovery-background-light.e5db6720.svg\",\"7qqQA\",\"gestural-line-dark.5fb5d96c.svg\",\"jmfnZ\",\"gestural-line.8591d4ac.svg\",\"jr06u\",\"jsw-add-people.17946c9a.svg\",\"jTG5T\",\"jsw-increased-storage-limits.b8a08bb1.svg\",\"iNU7h\",\"increased-storage-limits.a7321574.svg\",\"15Vzp\",\"unlimited-creators.3de71904.svg\",\"i0M9R\",\"help-desk-attachments-darkmode.a8bd959e.svg\",\"9zK71\",\"help-desk-attachments.138601ac.svg\",\"2hde5\",\"jsm-service-collection-add-people-darkmode.290a8179.svg\",\"j99t9\",\"jsm-service-collection-add-people.8f940b7d.svg\",\"anVlQ\",\"jsm-increased-storage-limits.21bb9c1c.svg\",\"cYQGZ\",\"unlimited-agents.743019a8.svg\",\"cHQ50\",\"location.970afe87.js\",\"aE4di\",\"phone.b88e8f90.js\",\"aKXvR\",\"payment-details-popup.08f90c43.js\",\"kwFai\",\"background.b3afa1bc.svg\",\"cDKlY\",\"plan-selection-page-modal.a41634d9.js\",\"4JtX7\",\"premium-add-payment-modal.a8b8b54d.js\",\"luoSj\",\"jpd-hierarchies.c6150f5d.svg\",\"73HLv\",\"jpd-roadmap.f097129b.svg\",\"lhoQv\",\"jpd-view-restrictions.3427d350.svg\",\"ki3nq\",\"premium-popup.340517ec.js\",\"czatF\",\"premiumPopupHeader-Dark.8772bafb.svg\",\"8oiny\",\"premiumPopupHeader-Light.587e53c0.svg\",\"7YE3I\",\"reverse-trial-popup.147d8845.js\",\"eCMUX\",\"standard-add-payment-modal.6eb6b3da.js\",\"lmoGI\",\"confluence-add-people.95d7cd0c.png\",\"1JrC5\",\"confluence-guest-access.0a003025.png\",\"cfLGc\",\"confluence-page-insights.548fcd17.png\",\"3DLtA\",\"confluence-page-restrictions.6ddf91dd.png\",\"dp0gI\",\"attachments.a7321574.svg\",\"7XFVr\",\"help-desk-attachements.21bb9c1c.svg\",\"7RlGN\",\"jpd-add-people.3de71904.svg\",\"4jaDc\",\"jsm-add-people.743019a8.svg\",\"kVhCr\",\"jsw-add-people.17946c9a.svg\",\"lLln8\",\"storage-hard-limit-modal.957ed207.js\",\"aCxGF\",\"storage-limit-breached-icon-dark-mode.c76c5af4.svg\",\"9WLSk\",\"storage-limit-breached-icon.604210d1.svg\",\"7hYpO\",\"storage-limit-danger-icon.9e7c0e3a.svg\",\"60S8F\",\"PremiumTrialOnboardingSpotlight.0000e9fc.js\",\"dTz74\",\"RtNeutralMessagingSuppressComponentsHoc.3fc925c6.js\",\"d5wRy\",\"Spotlight-pto2-dark.d9bc480a.svg\",\"fZEhl\",\"Spotlight-pto2-light.bfab086d.svg\",\"2E7bn\",\"Spotlight-pto2-dark-295x135.339d09e4.svg\",\"d3Q4u\",\"Spotlight-pto2-light-295x135.c27a4490.svg\",\"2OWSd\",\"PremiumOnboarding.ac6d7d90.js\",\"78YgQ\",\"Illustration.bc0cbd7b.svg\",\"bKgRA\",\"Illustration.bc0cbd7b.svg\",\"kAaiF\",\"FullPageEditorComponent.9e3191c8.js\",\"gM13h\",\"navBarButton.0dbc599e.js\",\"cLqmj\",\"navBarButton.104b6092.js\",\"8HiPp\",\"UpdateComposer.d82af8c1.js\",\"lR1oM\",\"PageLayout.b2ad699f.js\",\"kNFat\",\"ImpersonationFlag.ea6386ae.js\",\"dfdnK\",\"PageLayout.e2dd9d7c.js\",\"8dYdP\",\"BranchDeployLogo.bcf98801.js\",\"beF0E\",\"formatRelative.6270d915.js\",\"bkswC\",\"FeatureFlagLogo.4a098b0c.js\",\"392bg\",\"flag-filled.80b1588d.js\",\"5j5Dl\",\"NotificationsContent.699188f1.js\",\"2uVTT\",\"CommentsPanelWrapper.95c03d84.js\",\"g9CVe\",\"mention.063571ad.js\",\"lCT7Q\",\"GoalPanel.f5ce9654.js\",\"gfCPM\",\"NotificationsContent.554723c9.js\",\"cqJPj\",\"cs.0ec988ce.js\",\"k8s3i\",\"da.c2c29131.js\",\"4wXhf\",\"de.f2b6f89c.js\",\"6tXZg\",\"es.72f7c3e6.js\",\"ktJwC\",\"fi.1e13c97a.js\",\"7mgkS\",\"fr.ddece3e0.js\",\"fWDE2\",\"hu.d4e7285c.js\",\"b2OUm\",\"it.669e6609.js\",\"9PhiM\",\"ja.412f3646.js\",\"4d3pr\",\"ko.8d2b6e06.js\",\"duoZ2\",\"nb.2aed5fd9.js\",\"7JbfU\",\"nl.f57ffbf1.js\",\"k9Hsp\",\"pl.f9df15b1.js\",\"dNbgl\",\"pt_BR.c5cdb3ec.js\",\"53dLt\",\"ru.f643c2e3.js\",\"dCa0R\",\"sv.d1d14512.js\",\"dR545\",\"tr.6766db00.js\",\"gIlXN\",\"th.cd1a5d19.js\",\"ktxue\",\"uk.7fd9f774.js\",\"db0Tb\",\"vi.b22e706a.js\",\"cknqz\",\"zh_TW.8d331f4b.js\",\"8XnIU\",\"zh.0f2a0235.js\",\"44Ne1\",\"main.bf18fa50.js\",\"bZ7A8\",\"main.555475ad.js\",\"3xuDK\",\"show-more-vertical.91054f89.js\",\"5Qjce\",\"shortcut-pro-tip.9220bb06.js\",\"j5Z6Q\",\"main.9340f859.js\",\"eFvBU\",\"generic-error.74ae12d9.js\",\"19qJC\",\"avatar-group.f7644992.js\",\"brzrr\",\"main.6c73cb9c.js\",\"g5HUX\",\"GoalPanel.1211013d.js\",\"47RmW\",\"GoalPanel.2a565d52.js\",\"kTdzk\",\"ObjectSidebarControl.cd7329e4.js\",\"8Z2Eu\",\"main.6f77bf7a.js\",\"1y1ll\",\"main.870d36cb.js\",\"eYBaa\",\"main.ae75f0dc.js\",\"fzXjm\",\"QuickReload.ac4ef512.js\",\"aJ5As\",\"main.72219f2c.js\",\"7Rr0f\",\"dark-mode.c2768bcf.svg\",\"3U0yP\",\"light-mode.e7c3914f.svg\",\"fQA9e\",\"match-browser.a2bb9bea.svg\",\"27Dzv\",\"dark-mode.c2768bcf.svg\",\"1gUFj\",\"light-mode.e7c3914f.svg\",\"8s2Uo\",\"match-browser.a2bb9bea.svg\",\"49f46\",\"cs.077e9f4c.js\",\"jQPB7\",\"cs_CZ.02a4f979.js\",\"88bR1\",\"da.f100d419.js\",\"bwD1u\",\"da_DK.87972b77.js\",\"85kOD\",\"de.1d9843a9.js\",\"R2BG5\",\"de_DE.c262d848.js\",\"2goda\",\"en_GB.dbcbc037.js\",\"gjxqp\",\"en_ZZ.44473633.js\",\"1S2jF\",\"es.c17cb0b0.js\",\"eERmJ\",\"fi.4fa64611.js\",\"8rk64\",\"fi_FI.3920d863.js\",\"bpktO\",\"fr.903b8e7a.js\",\"aC2ty\",\"fr_FR.55477104.js\",\"lmJBr\",\"hu.531afc04.js\",\"lVBNt\",\"hu_HU.482ed985.js\",\"lnHpS\",\"it.87f71de5.js\",\"kEBAh\",\"it_IT.6068682f.js\",\"3ZAy1\",\"ja.94bc339c.js\",\"fDXOw\",\"ja_JP.b9c5af46.js\",\"45dhs\",\"ko.1eee672d.js\",\"grGen\",\"ko_KR.2eefe595.js\",\"4iqE9\",\"nb.2f604276.js\",\"bAyJY\",\"nb_NO.0e1c1672.js\",\"51EOq\",\"nl.6cc51681.js\",\"d5GjE\",\"nl_NL.36ecf941.js\",\"4ILPZ\",\"pl.1d15f5b3.js\",\"6QVYs\",\"pl_PL.4b70058e.js\",\"7HuII\",\"pt_BR.2b035f6a.js\",\"iYxvq\",\"ru.c3f08be2.js\",\"8kHli\",\"ru_RU.b5aa2be7.js\",\"dqRWB\",\"sv.937a087d.js\",\"bYWK5\",\"sv_SE.708683d2.js\",\"k0u9s\",\"th.1046cb5c.js\",\"imObn\",\"th_TH.951654d3.js\",\"chSc4\",\"tr.c7d5b86f.js\",\"dfeY8\",\"tr_TR.38e54197.js\",\"fvaoj\",\"uk.628c902d.js\",\"lT1ej\",\"uk_UA.7f80708f.js\",\"8OH5J\",\"vi.60bec7b2.js\",\"hV9Rr\",\"vi_VN.3f64294f.js\",\"k4zbq\",\"zh.74d31329.js\",\"1cNBX\",\"zh_CN.2e8ebc6e.js\",\"ii6TT\",\"zh_TW.222165d8.js\",\"iI96V\",\"NavigationSearchDialog.41c34b60.js\",\"lkRpX\",\"QuickFind.9d8040f0.js\",\"EfTik\",\"hoverCard.1eeaf7a2.js\",\"4KiYL\",\"image.77858b6c.js\",\"5GUmv\",\"search-error-dark.43e0a164.svg\",\"14R3W\",\"search-error-light.02ef2e6f.svg\",\"5nvBH\",\"landing-dark.4ee27e71.svg\",\"kv0qb\",\"landing-light.0988f0a2.svg\",\"8yV1V\",\"no-results-dark.a00ae47b.svg\",\"3bsGr\",\"no-results-light.5ca83755.svg\",\"1wZEW\",\"cards-extension.89b24fb5.js\",\"8Fuc5\",\"QuickFind.a3843959.js\",\"gD9D1\",\"cs.b146802c.js\",\"lpFHz\",\"da.c095ae7c.js\",\"fYKge\",\"de.e5cf5f36.js\",\"4Wlui\",\"en_GB.72965663.js\",\"69mwC\",\"en_ZZ.307d7928.js\",\"7rN2h\",\"es.fd819f8d.js\",\"9Y8tZ\",\"fi.3ae31506.js\",\"jjh1v\",\"fr.6de6a656.js\",\"23sVT\",\"hr.5ca2867d.js\",\"eO6VH\",\"hu.9ac1410f.js\",\"8rFvt\",\"it.d6f26172.js\",\"lK8aI\",\"ja.20197198.js\",\"5j4Hn\",\"ko.e2b7c7cf.js\",\"2Jfx0\",\"nb.fbff5dd6.js\",\"c119j\",\"nl.0c4b1ecf.js\",\"lgdNv\",\"pl.a2c15f6e.js\",\"dKIhk\",\"pt_BR.c09209f4.js\",\"dwqTf\",\"ru.dd3665d9.js\",\"fbezn\",\"sl.7ec8eb87.js\",\"3HAPT\",\"sr_RS.e426cadd.js\",\"2GH4w\",\"sr_YR.b4b10b84.js\",\"7Qzqz\",\"sv.2151dd26.js\",\"gt8Kd\",\"th.fbc22c4f.js\",\"eVDdh\",\"tr.2caa0d36.js\",\"hLIwJ\",\"uk.2e0c6168.js\",\"wnH66\",\"vi.85328ee8.js\",\"5oeby\",\"zh_TW.6bcf5f57.js\",\"2shw0\",\"zh.c4a33ecd.js\",\"ipx3Q\",\"cs.6e6d85a8.js\",\"jXMUM\",\"da.8430a65b.js\",\"idV8v\",\"de.42667ae6.js\",\"kBQ9k\",\"en.0a1911a7.js\",\"birQa\",\"en_GB.6f8d5ac9.js\",\"01Ull\",\"en_ZZ.87d0bff4.js\",\"iyrsM\",\"es.3973e72e.js\",\"hPFdF\",\"fi.8acfc715.js\",\"k7AqX\",\"fr.aa55a750.js\",\"8sFBs\",\"hr.ba0c864b.js\",\"iULA4\",\"hu.94d9be75.js\",\"gJ4Zj\",\"it.f0bac7b9.js\",\"fvcGb\",\"ja.6795775b.js\",\"30u08\",\"ko.1cb69361.js\",\"bEohT\",\"nb.9ac71b13.js\",\"4TfaY\",\"nl.0a7899c3.js\",\"7TRKR\",\"pl.ceddf0d1.js\",\"gfmgP\",\"pt_BR.eebb00c5.js\",\"8rjqC\",\"ru.310529a1.js\",\"c1meM\",\"sl.d30c360d.js\",\"hnoAT\",\"sr_RS.ab0c358e.js\",\"h2yiB\",\"sr_YR.81a4e171.js\",\"7t9jv\",\"sv.2d12cfe5.js\",\"02wkF\",\"th.a9ac77c8.js\",\"f9I75\",\"tr.341cd0ee.js\",\"2ArFg\",\"uk.3c5d8dfa.js\",\"a0qFU\",\"vi.5545bbf1.js\",\"3aliZ\",\"zh.95ba6e12.js\",\"k4Fbc\",\"zh_TW.76ca0d24.js\",\"aMWDh\",\"cs.828a8884.js\",\"2Nhk7\",\"da.acaedec6.js\",\"5GgLt\",\"de.61bd9901.js\",\"aeBaj\",\"en.71456958.js\",\"icI5m\",\"en_GB.86d7eb51.js\",\"56ebG\",\"en_ZZ.ca06b3db.js\",\"bpm6H\",\"es.1cbf292d.js\",\"lQBW4\",\"fi.36014db9.js\",\"d3Pby\",\"fr.85d5af6f.js\",\"i3KTR\",\"hr.3986ec3b.js\",\"jQsR5\",\"hu.28cebeae.js\",\"buYUs\",\"it.5c6e9b81.js\",\"6JyvA\",\"ja.1f75a0c6.js\",\"6j4E0\",\"ko.8e5f58a1.js\",\"dx2gW\",\"nb.1d25918e.js\",\"kRxC0\",\"nl.977a6ce0.js\",\"6VYUF\",\"pl.30631705.js\",\"iTCSz\",\"pt_BR.4ac37aa0.js\",\"9vlOp\",\"ru.28a28652.js\",\"9fdZA\",\"sl.cdacaf33.js\",\"c1Rfq\",\"sr_RS.0dcc2c8b.js\",\"b4t5O\",\"sr_YR.7eafa69f.js\",\"lPFUB\",\"sv.2575fe37.js\",\"cCO7Q\",\"th.afd2b044.js\",\"eGYFX\",\"tr.4aad6e6d.js\",\"e0Zpf\",\"uk.35fd5525.js\",\"3mO4w\",\"vi.b38f1b17.js\",\"fJV8L\",\"zh.56611b59.js\",\"aFaOB\",\"zh_TW.ba223b69.js\",\"c243Q\",\"cs.2a29509b.js\",\"9pwoj\",\"da.f85ed53c.js\",\"jbmlj\",\"de.000af340.js\",\"2YMwz\",\"en.25bc58a6.js\",\"apc1e\",\"en_GB.1ba9448b.js\",\"hSszq\",\"en_ZZ.45d09de4.js\",\"hMErM\",\"es.2e10b4ed.js\",\"4mauf\",\"fi.5c92bfdd.js\",\"cV78a\",\"fr.4f71955e.js\",\"a5JUA\",\"hr.6aadb1cb.js\",\"1MwbL\",\"hu.b6c6c45d.js\",\"4ep0R\",\"it.81e14be5.js\",\"6cdZj\",\"ja.7f372aa4.js\",\"aUGH0\",\"ko.fdf6c576.js\",\"bc9H8\",\"nb.a8e755f8.js\",\"jiPaz\",\"nl.3cc37fce.js\",\"7LXV4\",\"pl.9a4146f6.js\",\"dIeeW\",\"pt_BR.7128e5ea.js\",\"1NSIC\",\"ru.13459690.js\",\"iNY4f\",\"sl.263dec8c.js\",\"isQJH\",\"sr_RS.fd766dd2.js\",\"a60ql\",\"sr_YR.a4bc7a03.js\",\"4V1qv\",\"sv.638f613c.js\",\"8vbSC\",\"th.578e548f.js\",\"iwJOJ\",\"tr.81d297c9.js\",\"dlPIZ\",\"uk.56194425.js\",\"4Gbtc\",\"vi.adb49c2e.js\",\"eqiYF\",\"zh.0fe9e57a.js\",\"43BOc\",\"zh_TW.e1739f8d.js\",\"bvkZd\",\"no-results-dark.a00ae47b.svg\",\"cV42Q\",\"no-results-light.5ca83755.svg\",\"5bZfg\",\"QuickFind.ced2f6b5.js\",\"4L1zw\",\"work-item.ec0552af.js\",\"cMlHc\",\"24.c02b3c69.js\",\"jvHRs\",\"team-preview-panel.15b743f4.js\",\"fDx0F\",\"NavigationSearchDialog.3c7e0611.js\",\"efZH2\",\"recent-work-client.b69afda9.js\",\"8F6ik\",\"result-provider.e6d2d173.js\",\"hHoTx\",\"error-image.3cc4cf96.js\",\"lUh9w\",\"async-select.7073926f.js\",\"fEM7I\",\"static-select-filter.6fa97146.js\",\"bBtaF\",\"multi-select-filter.c24a0a7b.js\",\"3BloW\",\"image.d4dffd0f.js\",\"9RypW\",\"image.c1dded09.js\",\"4alnS\",\"no-results-light.5ca83755.svg\",\"bE2Fu\",\"no-results-dark.a00ae47b.svg\",\"6kNSo\",\"autocorrection-renderer.e8602d24.js\",\"eQXoP\",\"image.1b651d98.js\",\"yzZO6\",\"search-error-light.02ef2e6f.svg\",\"e84X7\",\"search-error-dark.43e0a164.svg\",\"6sXO4\",\"drop-down-links.e17363a5.js\",\"4Sse2\",\"image.e088a67d.js\",\"4KkwT\",\"prequery-empty-screen-light.0988f0a2.svg\",\"eM7lm\",\"prequery-empty-screen-dark.4ee27e71.svg\",\"5kEKD\",\"upsell-modal.535dc5c1.js\",\"kqtzG\",\"compass-bitbucket-upsell-banner.1bbe07cf.png\",\"jjAxo\",\"smart-user-picker.f35128ab.js\",\"8XFC9\",\"ai-answer-onboarding-banner.ab8c565b.js\",\"5QGog\",\"search-client.baefefd5.js\",\"fiCwF\",\"search-ai.b18c2697.js\",\"agAjs\",\"collapse-vertical.04b6b6cd.js\",\"dXz7U\",\"cs.6ac2769c.js\",\"gGEZv\",\"da.222013ff.js\",\"d3blt\",\"de.6adbea8d.js\",\"59Z93\",\"en_GB.1d2ad648.js\",\"kotjW\",\"en_ZZ.3637834b.js\",\"kK6se\",\"es.b72ae2e6.js\",\"5xf60\",\"et.7581eb28.js\",\"9VEIz\",\"fi.9db25ed3.js\",\"cjdHS\",\"fr.8f0bf0aa.js\",\"Whd6n\",\"hu.af2f8523.js\",\"jkUKZ\",\"is.a0ebfb14.js\",\"9LPlo\",\"it.78a22150.js\",\"bCZbu\",\"ja.5c6ea02b.js\",\"jUfGx\",\"ko.84af9550.js\",\"8yxgV\",\"nb.c9ca15dd.js\",\"dBE2i\",\"nl.3c0ffdcb.js\",\"6FNZU\",\"pl.f56c15cd.js\",\"ilWcC\",\"pt_BR.396aad53.js\",\"edU6Z\",\"pt_PT.94fccdb2.js\",\"atNxX\",\"ro.e8b3e3a3.js\",\"gpgvY\",\"ru.90486d02.js\",\"3IA7L\",\"sk.9ec26891.js\",\"hpq4P\",\"sv.64f386b7.js\",\"8WMbP\",\"th.6b4a37bf.js\",\"kffHA\",\"tr.081c0641.js\",\"2zh8u\",\"uk.a5713c75.js\",\"9YoTA\",\"vi.1ad21d1f.js\",\"a9qyt\",\"zh.c724084d.js\",\"04egH\",\"zh_TW.c65250a9.js\",\"1Ojgx\",\"ai-answer-prompt.8419794a.js\",\"eVnxm\",\"trello-body.492c187e.js\",\"2exA8\",\"trello-popper.35ef270b.js\",\"aKdQ9\",\"NavigationSearchDialog.e9a48d2a.js\",\"gPjUw\",\"NavigationSearchDialog.28820906.js\",\"1aPQ5\",\"PageLayout.bf6a2175.js\",\"6XyGC\",\"atlassian-switcher.174b9a1e.js\",\"4NUCi\",\"cs.ee14a273.js\",\"cSX69\",\"da.f99cdb04.js\",\"deZYh\",\"de.34ce4e12.js\",\"kU59n\",\"en_GB.b074670e.js\",\"1L3Og\",\"en_ZZ.7b508cd0.js\",\"6HKYn\",\"en.5ecea674.js\",\"UHyLS\",\"es.f027bd40.js\",\"7jCUc\",\"et.1dd8203e.js\",\"jq5xm\",\"fi.6a581f83.js\",\"anfIJ\",\"fr.7efdc03a.js\",\"369Q4\",\"hu.6ad16244.js\",\"1vaU3\",\"is.5d4b1a56.js\",\"23Iwb\",\"it.811d50f8.js\",\"fFLzH\",\"ja.93485558.js\",\"hVd5u\",\"ko.476beecb.js\",\"lz5E6\",\"nb.8e72f4f6.js\",\"bdV9c\",\"nl.b5e615f4.js\",\"eDHUW\",\"pl.6c50ac52.js\",\"RmhvD\",\"pt_BR.a6835abd.js\",\"dAgm7\",\"pt_PT.fb4e7968.js\",\"f7XN4\",\"ro.17474067.js\",\"bA1DV\",\"ru.b724c50e.js\",\"5Zouf\",\"sk.a983b13a.js\",\"f6c6x\",\"sv.4bf1c120.js\",\"6VL5F\",\"th.98547a2d.js\",\"9zarI\",\"tr.30dfa199.js\",\"gtgoF\",\"uk.6e958f1b.js\",\"kkSDy\",\"vi.16131c0b.js\",\"fgDwh\",\"zh_TW.1a4dacc3.js\",\"j25uO\",\"zh.d1eb4738.js\",\"9I9wd\",\"PageLayout.6694cffd.js\",\"2PUw9\",\"robot-error.9b710643.js\",\"hxVS9\",\"atlassian-switcher.ec21831d.js\",\"5dGIX\",\"animation-illustration.ceb03cfe.js\",\"a3B2V\",\"jira-switcher.6436bd0c.js\",\"9B1r0\",\"confluence-switcher.4bf2c185.js\",\"kgItH\",\"generic-switcher.695503de.js\",\"9aMWm\",\"PageLayout.4ced55ea.js\",\"eEBx4\",\"render.09a44acd.js\",\"6m2wP\",\"render.d180dc8c.js\",\"ctG9k\",\"render.987aadea.js\",\"2lwAY\",\"cross-flow-modal.5cb85009.js\",\"heta6\",\"brand-dark.c4f3aa1f.svg\",\"jCm4e\",\"brand-light.292da6ea.svg\",\"7yHad\",\"generic-error-dark.e889fb23.svg\",\"kVcQH\",\"generic-error-light.9c5910ae.svg\",\"a1o0C\",\"product-active-dark.56baffde.svg\",\"8pRM9\",\"product-active-light.b1a13a2d.svg\",\"inuR8\",\"maintenance-mode-dark.12d602d4.svg\",\"gNGNH\",\"maintenance-mode-light.587ad76e.svg\",\"6t3QQ\",\"confirmation-background-dark.77a50306.svg\",\"88MVa\",\"confirmation-background-light.7ebef9cd.svg\",\"g419T\",\"jpd-roadmap-dark.275cba67.svg\",\"9gS1d\",\"jpd-roadmap-light.6bcfd0e5.svg\",\"hgaNA\",\"jpd-timeline-dark.6be64e27.svg\",\"2T2WG\",\"jpd-timeline-light.91978564.svg\",\"fzxKX\",\"confirmation-background-dark.77a50306.svg\",\"cP3Ey\",\"confirmation-background-light.7ebef9cd.svg\",\"ajkXQ\",\"jsm-general-service-management-medium-dark.72053e0e.svg\",\"acQBx\",\"jsm-general-service-management-medium-light.235e9cbc.svg\",\"ke1cn\",\"loom-generic.bd9e0a28.svg\",\"avfpP\",\"loom-generic.4fa464c9.svg\",\"i7d4e\",\"background-light.e4dc0004.png\",\"anrcs\",\"discover-features.f4a0b670.png\",\"8uRyc\",\"avatar.65860ff3.svg\",\"h5M1J\",\"main.6f52f779.svg\",\"75jHc\",\"side-menu.7fc77990.svg\",\"2umcV\",\"avatar.19ae11ba.svg\",\"hmlCI\",\"main.b85f1cde.svg\",\"5TOLV\",\"side-menu.62c5751b.svg\",\"6nDfv\",\"esm.56e16210.js\",\"4Jbf1\",\"sprint.69e64865.js\",\"eONDg\",\"timeline.34add4cd.js\",\"gopxm\",\"render.923f067e.js\",\"9N316\",\"render.27a319cf.js\",\"603iI\",\"render.bf14e6f8.js\",\"dVwBo\",\"render.d1f351fb.js\",\"6gEtt\",\"render.f5338f1a.js\",\"l37ax\",\"render.0d906e7a.js\",\"ntv3W\",\"render.52132f97.js\",\"1b5ye\",\"render.c694410f.js\",\"lXsOU\",\"render.12903649.js\",\"8Y9rK\",\"welcome-animation-light.91126d70.js\",\"l1BtG\",\"welcome-animation-dark.09187bd2.js\",\"eBicT\",\"twc.f376f02d.svg\",\"e1SHP\",\"render.dd243c3f.js\",\"dUS4r\",\"confirmationBackgroundV2.dark.7c389c39.png\",\"6bGHk\",\"confirmationBackgroundV2.light.74baa5b8.png\",\"ksf6H\",\"confirmationVisual.dark.3beace2d.svg\",\"6H1xs\",\"confirmationVisual.light.4c2dbe9e.svg\",\"f0hWS\",\"teamworkCollectionHeaderV2.dark.88afbace.png\",\"77wr8\",\"teamworkCollectionHeaderV2.light.d5af8710.png\",\"eA4i6\",\"confirmationVisualNonTech.dark.2c7fab74.png\",\"l7wLG\",\"confirmationVisualNonTech.light.f155dfbb.png\",\"0N8pX\",\"confirmationVisualTech.dark.c6382480.png\",\"jL5hV\",\"confirmationVisualTech.light.e8e55ced.png\",\"egEVx\",\"teamworkCollectionHeaderV3.dark.71860723.svg\",\"3f67L\",\"teamworkCollectionHeaderV3.light.dfc683ca.svg\",\"3mvx6\",\"warning.f5011eb7.png\",\"2oFev\",\"teamwork_collection_header.dark.0d6ead39.png\",\"1BVx6\",\"teamwork_collection_header.light.46f39a8e.png\",\"lOVL5\",\"app-tiles.dark.8e97838c.png\",\"cqGeb\",\"app-tiles.light.c0171e78.png\",\"fYmaw\",\"normalizeSeatBackground.dark.3ce9cef1.png\",\"26YAb\",\"normalizeSeatBackground.light.c079ea47.png\",\"3EtHp\",\"provisioning.light.12580c01.js\",\"9m8Nr\",\"provisioning.dark.548ad10c.js\",\"4E6dy\",\"icons.light.bbb50d8d.js\",\"8JoSD\",\"icons.dark.b514e288.js\",\"bAOHw\",\"cs.415019f6.js\",\"h3G5z\",\"da.ff3287df.js\",\"gNA0J\",\"de.724308cd.js\",\"9kjAa\",\"en.fde66de2.js\",\"vaHqY\",\"en_GB.74b5c299.js\",\"hKKq1\",\"en_ZZ.5a8be184.js\",\"699rt\",\"es.9c700fe6.js\",\"4U6vo\",\"fi.a244137e.js\",\"8bauW\",\"fr.d0d5fc36.js\",\"2XHsa\",\"hr.ded63f63.js\",\"fQ6gV\",\"hu.c646eaf9.js\",\"8N1M8\",\"it.181f868f.js\",\"64SZl\",\"ja.522142eb.js\",\"l9rrS\",\"ko.ddf232bb.js\",\"1K1DB\",\"nb.e367ccb9.js\",\"2IhWo\",\"nl.4fd78782.js\",\"cB5tA\",\"pl.fe8da4e7.js\",\"14y9P\",\"pt_BR.5c828a18.js\",\"8BgQU\",\"ru.8afc7a3f.js\",\"kyH38\",\"sl.07c60fe8.js\",\"b8zkJ\",\"sr_RS.7dd76c2f.js\",\"2Ypcl\",\"sr_YR.fa171247.js\",\"g5vt7\",\"sv.425525c3.js\",\"aUgRr\",\"th.9b45c0ad.js\",\"dZlmW\",\"tr.34de4784.js\",\"dP9AS\",\"uk.efb4d88e.js\",\"7yahE\",\"vi.85a0717c.js\",\"kXGHC\",\"zh.0b71140a.js\",\"aparn\",\"zh_TW.38983b1a.js\",\"f7nCb\",\"render.91c24dae.js\",\"9xrtp\",\"render.ae40c469.js\",\"iFcso\",\"render.2c8a5b7c.js\",\"br5B5\",\"cs.0d4813ce.js\",\"gjHAC\",\"da.9847689c.js\",\"50jL1\",\"de.2ee49e34.js\",\"icT1H\",\"en-GB.7f03c10e.js\",\"jHACf\",\"en-US.74c2d95c.js\",\"gxykq\",\"en-XA.d9920a71.js\",\"jwi3q\",\"en-XB.c5f76386.js\",\"4vq5I\",\"en-ZZ.44357df6.js\",\"3IaOg\",\"es.b993872c.js\",\"c1t91\",\"et.96209c15.js\",\"5x1Zd\",\"fi.cabb4290.js\",\"eNry3\",\"fr.8386632f.js\",\"cmudZ\",\"hr.9eda1dd8.js\",\"qOVvt\",\"hu.ad90a636.js\",\"cLRtU\",\"it.c4f03750.js\",\"fWDs2\",\"ja.5e211822.js\",\"isQud\",\"ko.394e3512.js\",\"iX3CG\",\"nb.3d62fc61.js\",\"5GFyb\",\"nl.0393d573.js\",\"fDZox\",\"pl.d6663b00.js\",\"gYq2J\",\"pt-BR.6eab568f.js\",\"4MDcN\",\"ro.6b8de570.js\",\"djU0u\",\"ru.b0a1d17f.js\",\"gUvh2\",\"sl.adb9638d.js\",\"kb7kZ\",\"sr-RS.3b825f92.js\",\"kGHpg\",\"sr-YR.eb30ef98.js\",\"8GEyD\",\"sr.947e8003.js\",\"gSB6X\",\"sv.dd4339f1.js\",\"9s4Da\",\"th.061e58d9.js\",\"f73pl\",\"tr.f9cafb7d.js\",\"jmWj5\",\"uk.c3f28b54.js\",\"inGUf\",\"vi.8bcc9067.js\",\"9rQBn\",\"zh-CN.3ae80d8f.js\",\"4DECc\",\"zh-TW.faf09981.js\",\"3Kg3S\",\"CreateComponent.e27ec4b5.js\",\"82QsP\",\"InProductHelpButton.bc7f8513.js\",\"fYFVU\",\"UpflowV2ExperimentErrorBoundary.aefab094.js\",\"eRrWU\",\"EndUserRequestUpgradeModal.251b91be.js\",\"bGfxQ\",\"error-visual-dark.a52399eb.png\",\"djGcB\",\"error-visual-light.8a0abe86.png\",\"b71Lk\",\"project-avatar-cat.058f0f6d.svg\",\"awo0s\",\"telepointer-admin.a25fedb7.svg\",\"1nIbz\",\"telepointer-you.b2757941.svg\",\"8kpTd\",\"visual-dark.589bc948.png\",\"aPOi6\",\"visual-light.1c3bfa82.png\",\"bZz7X\",\"CommentsPanelFilterMenu.a53a34d7.js\",\"i4xbo\",\"CommentsPanelFilterMenu.0a7739ea.js\",\"6q8Rl\",\"CommentsPanelFooter.cb92249c.js\",\"8Ovry\",\"CommentEditor.814f1480.js\",\"fwuXj\",\"cardWithMediaClient.69ebd5f9.js\",\"8Ozg8\",\"inlinePlayer.57613299.js\",\"1oAGT\",\"shrink-diagonal.f22f633c.js\",\"kmmAT\",\"archive.114636ee.js\",\"8Ned5\",\"volume-high.22037e26.js\",\"c52tG\",\"video-skip-forward-ten.dfbb1d54.js\",\"fZ3WI\",\"video-skip-backward-ten.ce7698a0.js\",\"kFpjX\",\"video.c8c4f7cf.js\",\"cKkZK\",\"media-viewer-error-boundary.b53302e5.js\",\"bHwQq\",\"archive.82a538e0.js\",\"2OhRQ\",\"codeViewerRenderer.15b2821c.js\",\"3wpjh\",\"image.36e54009.js\",\"869mA\",\"video.db0aa5bd.js\",\"j7Vtd\",\"audio.e1381bfa.js\",\"f33Ay\",\"doc.fa11af2a.js\",\"2JEgu\",\"codeViewer.e1b4226d.js\",\"d3gsT\",\"codeViewer.c25f2630.js\",\"gTkiI\",\"codeViewer.fd65e68f.js\",\"aNesG\",\"dist.32d9fb42.js\",\"6v3DV\",\"dist.a4d87025.js\",\"FOgP0\",\"dist.1a1badb3.js\",\"laaZq\",\"dist.360031dc.js\",\"9ifQI\",\"dist.e418e7da.js\",\"dvdqq\",\"dist.27efad2d.js\",\"3CazT\",\"dist.b4af5be2.js\",\"gp06T\",\"dist.04df0ad8.js\",\"iXAeq\",\"dist.b54657cc.js\",\"1V58T\",\"dist.f02f9ba4.js\",\"bHvNW\",\"dist.9501f054.js\",\"ieE4C\",\"dist.81b1e5c1.js\",\"9CydI\",\"dist.5dd14922.js\",\"l0PXq\",\"dist.77dd9f1f.js\",\"bvFMP\",\"dist.6b9c7912.js\",\"hvnNT\",\"dist.548dd5e9.js\",\"jLuU0\",\"dist.d535090d.js\",\"exQrq\",\"dist.0edadf19.js\",\"fZOXw\",\"dist.1a9d9397.js\",\"edtrc\",\"dist.04d7d074.js\",\"fVBZH\",\"apl.7a0eb069.js\",\"ghj6h\",\"asciiarmor.c3b5105b.js\",\"g7DY3\",\"asn1.8960d6da.js\",\"69vjS\",\"asterisk.d216fca0.js\",\"qoDPM\",\"brainfuck.3493e766.js\",\"dCh4X\",\"cobol.19c1be5b.js\",\"69TDb\",\"clike.f4176504.js\",\"fTBPG\",\"clojure.13ae4d64.js\",\"7Nyzk\",\"css.df682f1f.js\",\"6Ww1h\",\"cmake.0d0ce1c4.js\",\"bX6oi\",\"coffeescript.f91dd720.js\",\"l0OtY\",\"commonlisp.ad5033b0.js\",\"j0Tov\",\"cypher.19076135.js\",\"dl0Ry\",\"python.c92392ae.js\",\"3jKkl\",\"crystal.dd910bbe.js\",\"5wWnH\",\"d.8b487736.js\",\"3pvGJ\",\"diff.86aeb138.js\",\"bL2K4\",\"dockerfile.6f5e2e2b.js\",\"3LCRx\",\"dtd.db73daa5.js\",\"imNro\",\"dylan.cd7e2cf8.js\",\"lnl9v\",\"ebnf.4a8cf82f.js\",\"jpYxQ\",\"ecl.96e6a496.js\",\"6YQ2N\",\"eiffel.093b27e1.js\",\"7nIe6\",\"elm.6327bd0e.js\",\"hHQRT\",\"erlang.1cdf5bfe.js\",\"hI20A\",\"sql.d9a93ca4.js\",\"lYlYq\",\"factor.4748b963.js\",\"9P7rU\",\"fcl.9474db5c.js\",\"fITeb\",\"forth.d7f3437f.js\",\"bxbTo\",\"fortran.f41c4883.js\",\"23Jq0\",\"mllike.56dc8cf4.js\",\"ajaZe\",\"gas.848679b9.js\",\"kL6oy\",\"gherkin.5552aa51.js\",\"lqGPZ\",\"groovy.8d056831.js\",\"kII2G\",\"haskell.c91e59d1.js\",\"i36zl\",\"haxe.3be11ce5.js\",\"hq2h4\",\"http.3dd37293.js\",\"1TSMN\",\"idl.7ee7a0ec.js\",\"bAZRe\",\"javascript.27f89868.js\",\"b3hNt\",\"jinja2.845f1627.js\",\"6UcU4\",\"julia.c06141f1.js\",\"iZo2Z\",\"livescript.a2a33b86.js\",\"bqYCz\",\"lua.7e3ce73c.js\",\"5dMhR\",\"mirc.11257b0a.js\",\"crYBi\",\"mathematica.e41b91c5.js\",\"2y1ZL\",\"modelica.121f8c84.js\",\"l2uCu\",\"mumps.06395c1b.js\",\"2Z5ZZ\",\"mbox.16659a61.js\",\"5DcAY\",\"nginx.9e06cde4.js\",\"is1HI\",\"nsis.10267711.js\",\"5diCl\",\"ntriples.496fd211.js\",\"3mnLX\",\"octave.0e1e65c3.js\",\"gXFxX\",\"oz.552c344a.js\",\"7RkzV\",\"pascal.04e79766.js\",\"hQW1J\",\"perl.8475d2a2.js\",\"kx6bO\",\"pig.d7f881f5.js\",\"khjYE\",\"powershell.c3bb0b31.js\",\"4LQtS\",\"properties.37ef214c.js\",\"fgry6\",\"protobuf.6099d0a8.js\",\"2D49w\",\"pug.2f2c8a16.js\",\"2iIvT\",\"puppet.d209abb9.js\",\"56vmr\",\"q.b2d2fe9a.js\",\"6M8mj\",\"r.77865540.js\",\"Bj9yK\",\"rpm.789cf7b7.js\",\"lsZih\",\"ruby.f62c0123.js\",\"9Rzyi\",\"sas.eabdba61.js\",\"14feQ\",\"scheme.f98cb495.js\",\"4a1CS\",\"shell.6f613319.js\",\"cS0Tl\",\"sieve.effa51d7.js\",\"fE1yG\",\"smalltalk.691a0573.js\",\"2RJND\",\"solr.3f1f1057.js\",\"dKpKN\",\"sparql.347b53c2.js\",\"hPyi8\",\"spreadsheet.86a982eb.js\",\"1MXZk\",\"stylus.8f67db3e.js\",\"gJn4m\",\"swift.da79331d.js\",\"i69ce\",\"stex.a172baf8.js\",\"cu9I0\",\"verilog.4309e460.js\",\"8AFLP\",\"tcl.185f046a.js\",\"cZ5wm\",\"textile.cfb1d1d7.js\",\"gjd1k\",\"tiddlywiki.582848a6.js\",\"hMQ12\",\"tiki.9c218db9.js\",\"2Lc7X\",\"toml.46d4fb02.js\",\"l6fIN\",\"troff.00dc7fd8.js\",\"hhZ9f\",\"ttcn.65ef0643.js\",\"imJrF\",\"ttcn-cfg.e713276f.js\",\"5e8eb\",\"turtle.8949abe4.js\",\"gOg0N\",\"webidl.39a3456f.js\",\"a0rhU\",\"vb.5f71d4fc.js\",\"2WM1v\",\"vbscript.4da55b21.js\",\"3EdpF\",\"velocity.ad754a83.js\",\"5EwPv\",\"vhdl.4b814e68.js\",\"3zaLm\",\"xquery.cb43bd9a.js\",\"ca7JM\",\"yacas.fc812212.js\",\"do9n8\",\"z80.d5f1a109.js\",\"hZQJQ\",\"mscgen.9da3d272.js\",\"dm0BU\",\"dist.8f7dcff2.js\",\"ijrLT\",\"dist.4421bcb4.js\",\"gQYJt\",\"svg.f7aab7a5.js\",\"azCDs\",\"zoom-out.14174f4b.js\",\"llcfA\",\"zoom-in.e40ea4e9.js\",\"cqNU4\",\"CommentWarningDialog.63a374d3.js\",\"hXu5I\",\"plussquare.3225068e.js\",\"a0oMZ\",\"ui.23239850.js\",\"iaptT\",\"Page.bf7344ca.js\",\"kG8pF\",\"ViewPage.9345e896.js\",\"4YF8c\",\"EditPage.18414942.js\",\"ja1FH\",\"inline-create-one-step.7ed78ab7.js\",\"3XbzG\",\"browser-extension.23c865dd.js\",\"k4PhO\",\"global-opt-in-default-image-banner.cf053e66.svg\",\"7GtpA\",\"EditorAppearanceButtonNext.0a77b7e5.js\",\"klllM\",\"media.8e454983.js\",\"5uHxI\",\"CommentEditor.71b890f6.js\",\"dnE79\",\"editor-ai-opt-in-banner.523b2454.svg\",\"dHQ6a\",\"AiInEditorModal.be10eff0.js\",\"f9Aq7\",\"AnimationContainerLight.5ba1bf64.svg\",\"kDDwa\",\"AnimationContainerDark.542af7ab.svg\",\"5IKAE\",\"CommentEditor.33ef6403.js\",\"N3kDR\",\"FullPageEditorComponent.f0a037c8.js\",\"6z3SN\",\"BrowseRovoAgentsModal.68b2918a.js\",\"h4mB6\",\"FullPageEditorComponent.8a6b6942.js\",\"eNZbx\",\"FullPageEditorComponent.runtime.13d74001.js\",\"1f9Ew\",\"FullPageEditorComponent.a011b3bd.js\",\"0sMQY\",\"FullPageEditorComponent.309c8b13.js\",\"fnlWy\",\"FullPageEditorComponent.15ccb822.js\",\"enrPB\",\"FullPageEditorComponent.runtime.00947e0a.js\",\"cXen0\",\"CommentEditor.a0e9a172.js\",\"6XNSn\",\"codeBlockAdvanced.d4347fbd.js\",\"9eC9n\",\"dist.71e1ce39.js\",\"2zsBw\",\"dist.6ad8cdf0.js\",\"jhJoI\",\"dist.fd78c557.js\",\"l7AiT\",\"languageSupport.0e008486.js\",\"g9tji\",\"codeBlockAdvanced.38ccf33d.js\",\"fM2zn\",\"FullPageEditorComponent.4d2afe1e.js\",\"kbsoN\",\"FullPageEditorComponent.runtime.1ede7525.js\",\"eNZbx\",\"FullPageEditorComponent.runtime.13d74001.js\",\"kbsoN\",\"FullPageEditorComponent.runtime.1ede7525.js\",\"enrPB\",\"FullPageEditorComponent.runtime.00947e0a.js\",\"cKm5l\",\"CommentsPanelFooter.20f87e84.js\",\"9qN8n\",\"CommentsPanelFooter.0128cf98.js\",\"8LtYa\",\"CommentsPanelFooter.23335592.js\",\"gYeBT\",\"CommentsPanelFooter.2d0d2708.js\",\"jtuzz\",\"CommentsPanelHeaderIcon.0be4955d.js\",\"gd3iv\",\"CommentsPanelWrapper.b12832db.js\",\"9fiFD\",\"getMonitoringClient.78ecb96c.js\",\"fH5Zm\",\"Attribution.01c00187.js\",\"bUC6C\",\"FeedbackCollector.67308004.js\",\"jjWia\",\"TableOfContents.cdd60931.js\",\"3ioZJ\",\"DateComponent.30fcabcf.js\",\"iTmpz\",\"EmojiComponent.ae8ea80d.js\",\"8OJBc\",\"MentionComponent.8f6e825d.js\",\"fDwDZ\",\"StatusComponent.011f3720.js\",\"8ublV\",\"CommentsPanelWrapper.c05a6144.js\",\"iEvs6\",\"json-schema-validation.12c711fd.js\",\"eBHYD\",\"modal.c723fc80.js\",\"1C6qR\",\"Reactions.ba408646.js\",\"dI1Cd\",\"CommentsPanelWrapper.d3a84e61.js\",\"iGCP8\",\"CommentsPanelWrapper.764a7396.js\",\"dvUU0\",\"FullPageEditorComponent.60700c7a.js\",\"lNrIG\",\"CommentsPanelWrapper.814fbd1a.js\",\"cLmw6\",\"CommentsPanelWrapper.2229990b.js\",\"4l6RQ\",\"CommentsPanelWrapper.e8b95d26.js\",\"bfveI\",\"CommentsPanelWrapper.77b934c9.js\",\"d24tW\",\"CommentsPanelWrapper.2b3146fc.js\",\"i8hiG\",\"UnreadIndicator.c9f9b434.js\",\"gs8si\",\"ConfluenceSmartCreationModalManager.22eb784c.js\",\"4XOEX\",\"cs.e0a70b47.js\",\"gqmha\",\"da.48cfbab1.js\",\"cweX3\",\"de.c8767744.js\",\"bai9u\",\"en_GB.2df39ad9.js\",\"9t1Ib\",\"en_ZZ.3d0895e5.js\",\"eHlQ9\",\"es.5d6eee32.js\",\"6abco\",\"fi.e8345104.js\",\"fvLDA\",\"fr.677c98af.js\",\"jYjnT\",\"hu.9ea72c86.js\",\"6chG6\",\"it.7d94cfcb.js\",\"bXBzb\",\"ja.74e96883.js\",\"fMgo4\",\"ko.f48b8bc8.js\",\"1HBhy\",\"nb.8f124772.js\",\"9YSn1\",\"nl.75d7c0f6.js\",\"40Jja\",\"pl.097351e1.js\",\"ibJOL\",\"pt_BR.71273029.js\",\"ipGTo\",\"ru.1c3aa9c4.js\",\"1dEiK\",\"sv.b0049c52.js\",\"bNIzh\",\"th.bf4e4f62.js\",\"bjl5Z\",\"tr.48095000.js\",\"7A6MW\",\"uk.d4d28cfc.js\",\"gu0nB\",\"vi.a8ee96b8.js\",\"2xhtF\",\"zh_TW.6ac6eb68.js\",\"iwPoV\",\"zh.92106a7f.js\",\"3VpLA\",\"initLoomSDK.2229cb8f.js\",\"2NjlT\",\"loom.41a125b9.js\",\"ixLhb\",\"PopupContent.584b7e09.js\",\"k97iL\",\"focus-area.6dcaf5d4.js\",\"5BMnr\",\"calendar-plus.435c4b76.js\",\"eZu0L\",\"goal.6283a63f.js\",\"l8LQp\",\"data-number.9bfeb2b4.js\",\"aqllW\",\"ProfileCard.b2b29dc3.js\",\"jiK0X\",\"GoalPanel.f1d74019.js\",\"9ZnhG\",\"th.71647b0c.js\",\"4Tiff\",\"uk.918f46f0.js\",\"iz8ME\",\"vi.6f47ac80.js\",\"1Pok1\",\"key-result.3e2e8c95.js\",\"jtcRz\",\"objective.9e034c80.js\",\"g55vn\",\"team.2a9babe4.js\",\"hjuEj\",\"project.1be4add3.js\",\"28VDA\",\"ProjectLinkerGoal.1d60668e.js\",\"m7vj2\",\"provider.29331aed.js\",\"gdS1N\",\"provider.0c84dc4d.js\",\"cs0k1\",\"th.bc465272.js\",\"gce4m\",\"uk.ff4881ca.js\",\"eFwGF\",\"vi.52b3bee6.js\",\"hLVzM\",\"suggested-edit.9edafd06.js\",\"b8oHe\",\"EngagementInlineDialogWrapper.bd6e32dd.js\",\"bu7LS\",\"UpFlowCommerceRouter.be6b3e59.js\",\"lgm1i\",\"StandaloneRestrictedPageOrSpace.d2829017.js\",\"gEi5K\",\"NotFound.75d584bc.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"kUiwW\",\"RestrictedPage.d7c16eeb.js\",\"5WZOQ\",\"CantViewLight.81544b8c.svg\",\"dHMTU\",\"CantViewDark.ef25ef94.svg\",\"cOpg6\",\"CantEditLight.0ee7f232.svg\",\"37OHY\",\"CantEditDark.190a22b1.svg\",\"2OcM6\",\"RestrictedSpace.247061ca.js\",\"6f3t8\",\"AdminKeyUpSell.58a0ce64.js\",\"euA5f\",\"SuperAdminEntryPoint.7d098154.js\",\"55AxV\",\"RestrictedContentIcon-Dark.bc90ae31.svg\",\"L0tFv\",\"RestrictedContentIcon-Light.e0fef1fb.svg\",\"7DDw1\",\"ConfluenceLogo.37570e84.svg\",\"k0WnS\",\"ExternalPageNotFoundV2.b1b6d347.js\",\"4J5D7\",\"not-found-v2.ab9d1086.svg\",\"9PQXU\",\"AppNavigation.dd99a344.js\",\"lwfE5\",\"ArchiveSpacePortal.c81e1bf6.js\",\"j06N4\",\"ArchiveSpacePanel.b5ce9a82.js\",\"d7sp9\",\"DeleteSpacePortal.013329d1.js\",\"ei0Jg\",\"SpaceSettingsForgeExtensionPortal.a1bb307a.js\",\"bGzhS\",\"ByLineForgeApp.809ee6fd.js\",\"bf0yj\",\"modal-dialog.4ea336eb.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"cjJTJ\",\"section-message.547b3afe.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"ci4aH\",\"FullPageEditorComponent.7420dc1e.js\",\"duC9l\",\"FullPageEditorComponent.runtime.a5656e94.js\",\"lqFMg\",\"ByLineForgeApp.4f7699b0.js\",\"1o23t\",\"ByLineForgeApp.56bb6b1f.js\",\"jigcs\",\"LabelsSelect.6eb8a17e.js\",\"718G0\",\"LabelsSelectErrors.15b7ddb3.js\",\"4LmEY\",\"ViewPageLabels.04e3bdd3.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.3df8d49a.js\",\"duC9l\",\"FullPageEditorComponent.runtime.a5656e94.js\",\"bdzih\",\"ContentActionForgeApp.f5b755ec.js\",\"cwpVK\",\"ContextMenuForgeApp.431174d7.js\",\"68RC4\",\"FullPageForgeApp.7266f888.js\",\"87cDu\",\"GlobalPageForgeApp.4062212e.js\",\"iXr0W\",\"GlobalSettingsForgeApp.2e7095a7.js\",\"ccJug\",\"HomepageFeedForgeApp.7c60748f.js\",\"irYLY\",\"SpaceSettingsForgeApp.abcf8493.js\",\"ldtPf\",\"SpacePageForgeApp.c3c551e1.js\",\"6wcNV\",\"CustomContentForgeApp.fc879b39.js\",\"i9jMB\",\"BackgroundScriptForgeApp.37288efe.js\",\"aFNXd\",\"PageBannerForgeApp.fe482561.js\",\"hhf8b\",\"SpaceTrashPortal.553b9b84.js\",\"an2zh\",\"SiteSettingsHelpPanelLink.48fe27c8.js\",\"gJRFC\",\"BackupManagerButton.90bacf33.js\",\"2NqiS\",\"dashboard-spa-container-jquery3.09ab2ae4.js\",\"49bJZ\",\"dashboard-spa-container-jquery3.runtime.cb2eb8c3.js\",\"hoCeh\",\"vendors.5865cb34.js\",\"eiF7i\",\"stable_vendors.2f3ed946.js\"]"));
 }, ["7EorR","2NqiS","49bJZ","hoCeh","eiF7i","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","cEqm7","6wr18"]);
$parcel$global.rwr("3pblT", () => { 
var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5QpZa = parcelRequire("5QpZa");


var $hp2SH = parcelRequire("hp2SH");


var $iC5L0 = parcelRequire("iC5L0");


var $aXEzU = parcelRequire("aXEzU");





var $3WLLD = parcelRequire("3WLLD");


var $bj5fB = parcelRequire("bj5fB");





var $7J5Uc = parcelRequire("7J5Uc");

const $14d55bbfca2abbc5$export$7a88623f52f1b79 = (initialTheme)=>{
    const [{ isInitialized: isInitialized }, { initializeTheme: initializeTheme }] = (0, $7J5Uc.useThemingState)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};


const $e6baa9171970034d$export$11eb671888ed6e7d = ({ children: children })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    const isInitialized = (0, $14d55bbfca2abbc5$export$7a88623f52f1b79)(initialTheme);
    if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $7zgzO = parcelRequire("7zgzO");


var $awd1Q = parcelRequire("awd1Q");


var $9j59h = parcelRequire("9j59h");


var $xwvlW = parcelRequire("xwvlW");


var $8PKGr = parcelRequire("8PKGr");


var $17wUi = parcelRequire("17wUi");


var $gnYQc = parcelRequire("gnYQc");


var $2DVQX = parcelRequire("2DVQX");


var $7ZzSP = parcelRequire("7ZzSP");


var $7LuKf = parcelRequire("7LuKf");





var $6g1oe = parcelRequire("6g1oe");


var $4xcIM = parcelRequire("4xcIM");


var $2FNjD = parcelRequire("2FNjD");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $cryCi = parcelRequire("cryCi");


var $dBmJE = parcelRequire("dBmJE");








var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $lonEO = parcelRequire("lonEO");


var $iJELi = parcelRequire("iJELi");


var $d5ap9 = parcelRequire("d5ap9");


var $hmRc4 = parcelRequire("hmRc4");


var $fcF01 = parcelRequire("fcF01");


var $iJiK8 = parcelRequire("iJiK8");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $25MM7 = parcelRequire("25MM7");





var $jVK0t = parcelRequire("jVK0t");


var $64KID = parcelRequire("64KID");


var $kZDrw = parcelRequire("kZDrw");


var $8n9tL = parcelRequire("8n9tL");


var $1ytiN = parcelRequire("1ytiN");


var $a5txT = parcelRequire("a5txT");


var $97W74 = parcelRequire("97W74");

class $7db816b9e13721ff$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { store: store } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                (0, $a5txT.getStandalonePageTreeStateUpdater)()
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
            history: this.browserHistory,
            context: (0, $kFqI2.ReactReduxContext)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
            namedRoutes: (0, $64KID.namedRoutes)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), this.props.children))))))))))));
    }
    constructor(...args){
        super(...args);
        this.browserHistory = (0, $hmRc4.getBrowserHistory)();
    }
}
$7db816b9e13721ff$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    /**
   * Children Component
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    /**
   * Indicates if the component is rendered as Root
   */ renderAsRoot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");

const $d4f95b5cede9219f$var$store = (0, $3Tw8v.default)({
    isServerRenderedPage: true
});
(0, $9F7Qb.subscribe)($d4f95b5cede9219f$var$store);
/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */ const $d4f95b5cede9219f$var$renderComponentIntoDOM = (children, container, renderAsRoot = false)=>{
    if (typeof container === 'string') container = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.getElementById(container);
    const Component = ({ sessionData: sessionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7db816b9e13721ff$export$2e2bcd8739ae039), {
            store: $d4f95b5cede9219f$var$store,
            renderAsRoot: renderAsRoot
        }, children)));
    Component.propTypes = {
        sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
    };
    (0, $ge2sX.getSessionData)().then((sessionData)=>{
        const concurrentComponentWrapper = (0, $2FNjD.createRoot)(container);
        concurrentComponentWrapper.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            sessionData: sessionData
        }));
    });
};
var $d4f95b5cede9219f$export$2e2bcd8739ae039 = $d4f95b5cede9219f$var$renderComponentIntoDOM;



var $7RVQB = parcelRequire("7RVQB");




/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */ const $8bee1fe38b9eef04$var$mainSectionsSelectors = [
    '#main',
    '#admin-content',
    '#custom-content-container',
    '.ap-servlet-placeholder'
];
const $8bee1fe38b9eef04$export$ed04e7f6ba662aee = ()=>{
    const head = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.head || (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('head');
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createElement('style');
    const css = `${$8bee1fe38b9eef04$var$mainSectionsSelectors.join(',')} { opacity: 0 };`;
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createTextNode(css));
    if (head) head.appendChild(style);
};
const $8bee1fe38b9eef04$export$4011f4c5a8044281 = (runs = 0)=>{
    const mainContainers = $8bee1fe38b9eef04$var$mainSectionsSelectors.map((selector)=>(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector(selector)).filter((ele)=>ele !== null);
    if (mainContainers.length) mainContainers.forEach((container)=>{
        if (container) {
            container.style.transition = 'opacity .15s ease-in';
            container.style.opacity = '1';
        }
    });
    else // accounting for any race condition that could delay the parsing of the content
    if (runs < 5) {
        console.warn('Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet');
        setTimeout(()=>$8bee1fe38b9eef04$export$4011f4c5a8044281(runs + 1), 100);
    } else console.error('Legacy pages: content container was not found');
};






var $iyEDi = parcelRequire("iyEDi");


var $gnnzK = parcelRequire("gnnzK");


var $1NBp8 = parcelRequire("1NBp8");

/* StandaloneConfluenceNavigation.js generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $3pfAb = parcelRequire("3pfAb");


var $NAPtM = parcelRequire("NAPtM");


var $3u0dr = parcelRequire("3u0dr");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");











var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $cs1vW = parcelRequire("cs1vW");


var $30qWc = parcelRequire("30qWc");





var $gqqjz = parcelRequire("gqqjz");








var $b1HmN = parcelRequire("b1HmN");

/**
 * @generated SignedSource<<1ebd2e694fec163835268b1787cd6887>>
 * @relayHash 737a60122b0a1fbdaa4709876ac5fba5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea
const $d6dcaac643994a17$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentRestrictionsPageResponse",
            "kind": "LinkedField",
            "name": "clearRestrictionsForFree",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "restrictionsHash"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "737a60122b0a1fbdaa4709876ac5fba5",
            "id": "f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea",
            "metadata": {},
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "operationKind": "mutation",
            "text": "mutation ChangeEditionClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}"
        }
    };
}();
$d6dcaac643994a17$var$node.hash = "a6f31038cfbb195a7ec707513d6d3235";
var $d6dcaac643994a17$export$2e2bcd8739ae039 = $d6dcaac643994a17$var$node;


const $c9e67d6bb8fbd3cb$export$c8d7574a93f4b7d4 = (0, $d6dcaac643994a17$export$2e2bcd8739ae039);


const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $h82at.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $h82at.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $c9e67d6bb8fbd3cb$export$c8d7574a93f4b7d4),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $cs1vW.default)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);


















var $frIzR = parcelRequire("frIzR");







var $1cfRh = parcelRequire("1cfRh");





var $4WmbV = parcelRequire("4WmbV");

const $4c2daaa3bc0c282d$var$i18n = (0, $h82at.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    let t0;
    if ($[0] !== formatMessage || $[1] !== title) {
        t0 = formatMessage(title);
        $[0] = formatMessage;
        $[1] = title;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== body || $[4] !== formatMessage) {
        t1 = formatMessage(body);
        $[3] = body;
        $[4] = formatMessage;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            title: t0,
            body: t1,
            source: "auditLogs"
        });
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};




















var $f7Bnv = parcelRequire("f7Bnv");




const $ee74963fbde2c4ed$var$i18n = (0, $h82at.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { grandfathered: grandfathered, isSiteAdmin: isSiteAdmin } = t0;
    const intl = (0, $1cfRh.default)();
    let T0;
    let t1;
    let t2;
    if ($[0] !== grandfathered || $[1] !== intl || $[2] !== isSiteAdmin) {
        const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
        const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
        T0 = (0, $4WmbV.ChangeEditionSectionMessage);
        if ($[6] !== intl || $[7] !== title) {
            t1 = intl.formatMessage(title);
            $[6] = intl;
            $[7] = title;
            $[8] = t1;
        } else t1 = $[8];
        t2 = intl.formatMessage(bodyText);
        $[0] = grandfathered;
        $[1] = intl;
        $[2] = isSiteAdmin;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    let t3;
    if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            title: t1,
            body: t2,
            source: "individualSpaceRestrictedPages"
        });
        $[9] = T0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $1cfRh.default)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);


const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $42omo.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $ee74963fbde2c4ed$export$51350d82d36f7e43),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $4c2daaa3bc0c282d$export$cb2ba78fe55aff74)
        };
    }
}


const $f60f9bb0af41c642$export$ddc928ad192d2b94 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $bQm3c.useSessionData)().edition === "FREE" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;
} : ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;






var $4PPzL = parcelRequire("4PPzL");


var $04e9M = parcelRequire("04e9M");


var $56QzY = parcelRequire("56QzY");


var $1dnxO = parcelRequire("1dnxO");


var $aeSHO = parcelRequire("aeSHO");


var $iJ8K8 = parcelRequire("iJ8K8");


var $4l6Wo = parcelRequire("4l6Wo");


var $5ZPtT = parcelRequire("5ZPtT");


var $eWwvy = parcelRequire("eWwvy");


var $39rFu = parcelRequire("39rFu");





var $cBuRD = parcelRequire("cBuRD");





var $eIKcA = parcelRequire("eIKcA");





var $ezLwY = parcelRequire("ezLwY");

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */ function $089e60b6c1a73ffc$var$shortcutContext(context) {
    return (BaseComponent)=>{
        class ShortcutContextComponent extends (0, $42omo.Component) {
            componentDidMount() {
                (0, $ezLwY.enableContext)(context);
            }
            componentWillUnmount() {
                (0, $ezLwY.disableContext)(context);
            }
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, this.props);
            }
        }
        ShortcutContextComponent.displayName = `ShortcutContextComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return ShortcutContextComponent;
    };
}
var $089e60b6c1a73ffc$export$2e2bcd8739ae039 = $089e60b6c1a73ffc$var$shortcutContext;



var $jmjWc = parcelRequire("jmjWc");


const $f05a18473f890654$export$ffff49ea750347f8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3CTAv",
    name: "StandaloneRestrictedPageOrSpace",
    loader: async ()=>(await (parcelRequire("fmuCC"))).StandaloneRestrictedPageOrSpace
});



var $jwv1p = parcelRequire("jwv1p");


var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $4QflW = parcelRequire("4QflW");





var $ba9cbe60fdf9141e$exports = {};

var $bCMS0 = parcelRequire("bCMS0");


var $daAKm = parcelRequire("daAKm");


var $ehlgT = parcelRequire("ehlgT");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $ba9cbe60fdf9141e$var$endsWith(string, target, position) {
    string = $fPVB6(string);
    target = $daAKm(target);
    var length = string.length;
    position = position === undefined ? length : $bCMS0($ehlgT(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$ba9cbe60fdf9141e$exports = $ba9cbe60fdf9141e$var$endsWith;



var $jzEl8 = parcelRequire("jzEl8");

const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED = [
    '#action-page-permissions-link'
];
const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = [
    '#page-favourite',
    '#action-menu-link'
];
const $9117dce6b863f439$var$replacedPlaceholder = {
    elementName: 'span',
    attributes: {
        style: `display: none`
    }
};
function $9117dce6b863f439$export$9e2c81a475b5d1b8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED,
        attempts: 100,
        retryDelay: 500,
        portalNode: null,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ba9cbe60fdf9141e$exports)))(window.location.pathname, '/pages/viewinfo.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION,
        attempts: 100,
        retryDelay: 500,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder,
        portalNode: null
    }));
}














var $inPa6 = parcelRequire("inPa6");








const $b82761c2a95901d5$export$18a8a22069631f81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kdP2C",
    loader: async ()=>(await (parcelRequire("5qwh1"))).ArchiveSpacePortal,
    name: 'ArchiveSpacePortal'
});






const $e87d969ba20a20a0$export$854f67824ef9311 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "P3ji1",
    loader: async ()=>(await (parcelRequire("2NJWg"))).DeleteSpacePortal,
    name: 'DeleteSpacePortal'
});






const $a6c6b76f924ecb80$export$b4b583c595949768 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BlJ6r",
    name: "LazySpaceSettingsForgeExtensionPortal",
    loader: async ()=>(await (parcelRequire("cq0jI"))).SpaceSettingsForgeExtensionPortal
});
$a6c6b76f924ecb80$export$b4b583c595949768.displayName = 'LazySpaceSettingsForgeExtensionPortal';



var $7QM6o = parcelRequire("7QM6o");


var $feuG2 = parcelRequire("feuG2");





const $b270d87888ab1caf$export$cca256d7c562dc07 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTzRP",
    loader: async ()=>(await (parcelRequire("7nmkU"))).SpaceTrashPortal,
    name: 'SpaceTrashPortal'
});






const $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wu877",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("g2IUi"))).SiteSettingsHelpPanelLink
});






const $406f60e313bf3a3f$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h3QZB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("1xDOQ"))).BackupManagerButton
});



var $14QAi = parcelRequire("14QAi");


var $ep3mz = parcelRequire("ep3mz");

/* PdfBannerPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");





var $6mKj3 = parcelRequire("6mKj3");

const $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID = 'pdf-export-banner-root';
const $530cf45a0f14746c$var$i18n = (0, $h82at.defineMessages)({
    bannerMessage: {
        id: "pdf-export.banner.message",
        defaultMessage: "We've received your print request. To maintain your page's format, we're exporting it to a PDF for you to download and print."
    }
});
const $530cf45a0f14746c$var$styles = {
    bannerStyles: "_1yt4pxbi _bfhk1aqn _1bto1l2s _o5721q9c"
};
const $530cf45a0f14746c$var$PdfBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $530cf45a0f14746c$var$styles.bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $530cf45a0f14746c$var$i18n.bannerMessage)));
const $530cf45a0f14746c$export$57cc11a378563774 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    if (!(0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true)) return null;
     // only inject if ?showPdfBanner=true
    if (queryParams.showPdfBanner !== 'true') return null;
    let targetElement = document.getElementById($530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID); // if the target doesn't exist, create and insert it before <main>
    if (!targetElement) {
        const main = document.querySelector('main#main');
        if (main && main.parentElement) {
            targetElement = document.createElement('div');
            targetElement.id = $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID;
            main.parentElement.insertBefore(targetElement, main);
        }
    } // if no anchor could be found, bail
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($530cf45a0f14746c$var$PdfBanner, null), targetElement);
};


const $76c1a3880217c32d$var$i18n = (0, $h82at.defineMessages)({
    importingTemplates: {
        id: "standalone-navigation.importing.templates",
        defaultMessage: "More about importing templates"
    }
});
const $76c1a3880217c32d$export$fc287ab47b11c4ec = ({ spaceKey: spaceKey, isSpaceSettingsScreen: isSpaceSettingsScreen })=>{
    const { location: { pathname: pathname } } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $42omo.useEffect)(()=>{
        const { section: section, screen: screen } = (0, $14QAi.getRouteData)(pathname);
        // We only want analytics for IPH specific routes for now
        if (screen !== 'notTracked') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screen,
                attributes: {
                    section: section
                }
            }
        }).fire();
    }, [
        pathname,
        createAnalyticsEvent,
        spaceId
    ]);
    return pathname && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isSpaceSettingsScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageStateContainer), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsNavigationV2Portal), {
        spaceKey: spaceKey
    })) : null, pathname.includes('/spaces/archivespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b82761c2a95901d5$export$18a8a22069631f81), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/spaces/removespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e87d969ba20a20a0$export$854f67824ef9311), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/pages/viewtrash.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b270d87888ab1caf$export$cca256d7c562dc07), {
        spaceKey: spaceKey
    }), pathname.includes('/templatePackage/configurePlugin.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e), {
        articleId: "7p0QTJJI0VkoU49M4GzKH2",
        articleTopic: "admin-import-templates",
        portalTargetId: "site-settings-import",
        buttonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $76c1a3880217c32d$var$i18n.importingTemplates),
        pathname: pathname,
        routeGroup: "site-settings",
        routeName: "undefined"
    }), pathname.includes('/plugins/servlet/ondemandbackupmanager') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $406f60e313bf3a3f$export$b52880da76836cd4), {
        pathname: pathname
    }), pathname.includes('spaces/flyingpdf/pdfpageexport.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $530cf45a0f14746c$export$57cc11a378563774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6c6b76f924ecb80$export$b4b583c595949768), {
        spaceKey: spaceKey
    }));
};
// needed for react-proptypes warning
$76c1a3880217c32d$export$fc287ab47b11c4ec.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};


var $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation;
function $7c0ba11073bcb5f1$var$_defineProperty(e, r, t) {
    return (r = $7c0ba11073bcb5f1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c0ba11073bcb5f1$var$_toPropertyKey(t) {
    var i = $7c0ba11073bcb5f1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c0ba11073bcb5f1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7c0ba11073bcb5f1$var$TopNavSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1bsb1osq _4t3iymf6",
            __cmplp.className
        ])
    });
});
var $7c0ba11073bcb5f1$export$2e2bcd8739ae039 = (0, $089e60b6c1a73ffc$export$2e2bcd8739ae039)('global')(($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation = class StandaloneConfluenceNavigation extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { isAdminScreen: isAdminScreen } = this.props; // if admin screen, show content as we mount
        if (isAdminScreen) (0, $8bee1fe38b9eef04$export$4011f4c5a8044281)();
        else setTimeout((0, $8bee1fe38b9eef04$export$4011f4c5a8044281), 300);
        (0, $ge2sX.getSessionData)();
    }
    render() {
        const { isAdminScreen: isAdminScreen, isSpaceSettingsScreen: isSpaceSettingsScreen, isSpaceScreen: isSpaceScreen, route: route, spaceKey: spaceKey } = this.props;
        let navView;
        if ((0, $1dnxO.getIsNav4Enabled)() && isSpaceSettingsScreen) navView = (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID);
        else if (isSpaceSettingsScreen || isSpaceScreen) navView = (0, $4l6Wo.CONTAINER_HOME_ID);
        else if (isAdminScreen) navView = (0, $4l6Wo.ADMIN_HOME_ID);
        else if (route?.name !== (0, $1NBp8.EXTERNAL_SHARE).name) // XXX EXTERNAL_SHARE does not have the typical navigation.
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f05a18473f890654$export$ffff49ea750347f8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76c1a3880217c32d$export$fc287ab47b11c4ec), {
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
            nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
            livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
            screenEvent: {
                name: 'serverRenderedScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW)
            }
        }, navView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ZPtT.PageLayout), {
            view: navView,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            standalone: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), isSpaceSettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            entryPoint: "spaceSettings"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9117dce6b863f439$export$9e2c81a475b5d1b8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f60f9bb0af41c642$export$ddc928ad192d2b94), null));
    }
    constructor(...args){
        super(...args);
        $7c0ba11073bcb5f1$var$_defineProperty(this, "spacer", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c0ba11073bcb5f1$var$TopNavSpacer, {
                "data-test-id": "top-nav-spacer"
            }));
    }
}, $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "displayName", 'StandaloneConfluenceNavigation'), $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "propTypes", {
    isAdminScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    route: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
}), $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation));


const $fe485fa379bdff14$var$getSpaceKey = (state)=>{
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    return (0, $iyEDi.routerStateExists)(state) && routeParams && routeParams.spaceKey || state.meta.get('space-alias') || state.meta.get('space-key');
};
const $fe485fa379bdff14$var$mapStateToProps = (state, props)=>{
    const { location: location, matchRoute: matchRoute } = props;
    const isSpaceScreen = state.meta.get('is-space-page') === 'true' || (0, $gnnzK.isContentTypeOf)('page', state) || (0, $gnnzK.isContentTypeOf)('blogpost', state);
    //On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
    //use the spaceKey. Set spaceKey to null if on this path
    const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);
    const spaceKey = route?.name === (0, $1NBp8.DELETE_SPACE_LEGACY).name ? null : $fe485fa379bdff14$var$getSpaceKey(state);
    return {
        isAdminScreen: state.meta.get('is-admin-page') === 'true',
        isSpaceScreen: isSpaceScreen,
        isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
        route: route,
        spaceKey: spaceKey
    };
};
var $fe485fa379bdff14$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($fe485fa379bdff14$var$mapStateToProps)((0, $7c0ba11073bcb5f1$export$2e2bcd8739ae039));


/**
 * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
 * This ensures we catch and track any errors that occur during the app's initialization,
 * including async operations and React rendering. Moving this call later would risk missing
 * early errors.
 * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
 */ (0, $5QpZa.default)();
const $f5e2aff200456a49$var$sessionDataPromise = (async ()=>{
    (0, $hp2SH.getApolloClient)();
    try {
        const sessionData = await (0, $aXEzU.getSessionDataAndInitializeStatsig)();
        // Initialize browser storage controls after Statsig is ready (for proper feature gate evaluation)
        // This must happen before initializeStorageManager
        await (0, $7ZzSP.initializeBootstrapStorage)({
            userId: sessionData.userId,
            cloudId: sessionData.cloudId
        });
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        await (0, $17wUi.initializeStorageManager)({
            userId: userId,
            isLicensed: isLicensed
        });
        (0, $gnYQc.applyPersistedStatsigOverrides)();
        return sessionData;
    } catch  {
        // For the same reasons as in the non-standalone case documented in the
        // counterpart of this file which is
        // confluence/packages/confluence-frontend-server/src/index.js at the moment
        return (0, $iC5L0.getEmptySessionData)();
    }
})();
const $f5e2aff200456a49$var$translationPromise = (0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage));
Promise.all([
    $f5e2aff200456a49$var$sessionDataPromise,
    $f5e2aff200456a49$var$translationPromise
]).then(([sessionData])=>{
    const browserNotSupportedCheck = (0, $2DVQX.coreBrowserNotSupported)();
    // the only requirement for BrowserNotSupported to render is the translationPromise
    if (browserNotSupportedCheck) {
        // the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
        const documentBody = document.getElementById('com-atlassian-confluence');
        // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), documentBody);
    }
    (0, $7LuKf.initialization)(sessionData);
    (0, $8bee1fe38b9eef04$export$ed04e7f6ba662aee)();
    (0, $d4f95b5cede9219f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6baa9171970034d$export$11eb671888ed6e7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe485fa379bdff14$export$2e2bcd8739ae039), {
            apolloClient: (0, $hp2SH.getApolloClient)(),
            location: location,
            matchRoute: matchRoute
        }))), 'ui-global-sidebar-section', true);
});
 }, ["7EorR","2NqiS","49bJZ","hoCeh","eiF7i","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","cEqm7","6wr18"]);

$parcel$global.rlb("3pblT")
//# sourceMappingURL=standalone-navigation-jquery3.a85f8b9b.js.map
